import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import PendingIcon from "@mui/icons-material/Pending";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Box from "@mui/material/Box";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import GCBatch from "../../Component/Common/ReuseableComponent/GCBatch";
import GCSimpleSearch from "../../Component/Common/ReuseableComponent/GCSimpleSearch";
import GCSearchBtn from "../../Component/Common/ReuseableComponent/GCSearchBtn";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  fAlertToast,
  fCalculate_Detail,
  GetGitterColumns,
  fKeyTabInput,
  fFocusInput,
  GetLinkDocument,
  fCheck_Doc_Rights_001,
  FShortCutKey,
  GetAccountPostingDetail,
  DisableApproveFlag,
  fcheck_null_undefine_replace_empty,
  fcovertToNumber,
  PdfUpload,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";

import { GRNNormalRo, vRdxUserInfo } from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Footer from "./processComponent/Footer";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  Set_GRNNormal_HeadObject_Set,
  Set_GRNNormal_HeadObject_Init,
  Set_GRNNormal_HeadObject_A_VocNo,
  Set_GRNNormal_HeadObject_DrCrAccount,
  Wms_GRNNormal_HeadObject_New_Set,
  Wms_GRNNormal_HeadObject_RefNo_ExactSearch_Set,
  Set_GRNNormal_HeadObject_A_DocStat,
  Set_GRNNormal_HeadObject_TaxType,
} from "./SliceGRNNormal";
import "./GRNNormal.css";

import {
  CmpButtonKIcon,
  SalesInvoiceCmpButton001,
} from "../../Component/Common/ToolBox/ToolBox";
import GCLandedCost from "../../Component/Common/ReuseableComponent/GCLandedCost";
import {
  fRightClick,
  fLeftClick,
  sFocFlagArr,

  //GCLOADECOST
  sLoadedCostAccountArr,
  sLoadedCostToggleData,
  Loaded_Cost_Freight_Init,
  Get_LoadedCost,
  Get_Loaded_Cost_WMINV03D_GetRow,
  sPaymode,
  sTax,
  sTrnTyp,
  TypeArr,
  sStatusArr,
  fKey,
  GetRefDocInbound,
  GetUnitArr,
  GetUnitRateArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  BatchDetail_ErrorMsg_Init,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fDisplay,
  //refdoc
  fRefDocRowClick,
  fCloseRefDocSearchModal,
  vHeaderSearchInit,
  //reverse
  fCloseReverseTransactionModal,
  fReverse,
  GetTransTaxType,
  fDefaultPayload,
  //batch
  fValidationBatch_Client,
  GetSaveDetailBatch,
  GetDeleteDetailBatch,
  GetBatchDetail,

  //ref doc
  fReset_Linewise_Rebate,
  fDiscFlagDependency,
  GetDefcustomersetting,

  //GC customer
  Get_ToggleDropDown_Load,
  // xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  Get_GCSearchBtn,
  // xGCSearchBtn_Columns_DropdownSearch,
  GetAttributes,
  GetMSPUpdate,
  GetPengingPo,
  GetPallet,
  GetUnitRate,
  Unit_Onchange_001,
} from "./GRNNormalAction";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCMSPUpdate from "./processComponent/GCMSPUpdate";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import {
  ApproveconfirmationINV03,
  Grn_ConfirmINV03LineItem_GETROW,
  GRNNormal_ApproveINV03_GETROW,
  GRNNormal_BUYER_GETROW_GETROW,
  GRNNormal_fINV02_Head_Detail_Barcode_GETROW,
  GRNNormal_fINV03_Delete_GETROW,
  GRNNormal_fINV03_fDiscCalc_GETROW,
  GRNNormal_FreightUpdate_GETROW,
  GRNNormal_INV03_Search_GETROW,
  GRNNormal_InvTransReverseINV03_GETROW,
  GRNNormal_RefDocumentNo_GETROW,
  GRNNormal_RefDocumentType_GETROW,
  GRNNormal_saveInv03_GETROW,
  GRNNormal_validationINV03_GETROW,
  WMSIInbound_WMINV03MSPSave_API,
} from "./../../Server/ApiV2";
import GCPendingStock from "./processComponent/GCPendingStock";
import { GRNNormalDetailTblCard } from "./processComponent/GRNNormalDetailTblCard";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCPallet from "./processComponent/GCPallet";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import PoNoSearchModal from "./processComponent/PoNoSearchModal";
import POTypeSearchModal from "./processComponent/POTypeSearchModal";
import FileUploadModal from "../../Component/Common/ReuseableComponent/FileUpload";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";
import { IconButton } from "@mui/material";
import GCStockSetupChangeReq from "../../Component/Common/ReuseableComponent/GCStockSetupChangeReq";

export default function GRNNormal() {
  const dispatch = useDispatch();

  const location = useLocation();

  //if GRNDocTyp, GrnDocNo is not empty then it is from notification page
  // so redirect to notification page in mobile screen
  const { GRNDocTyp, GrnDocNo, RefNo, RefVocNo, RefVocTyp } = !!location.state
    ? location.state
    : {
        GRNDocTyp: "",
        GrnDocNo: "",
        RefNo: "",
        RefVocNo: "",
        RefVocTyp: "",
      };

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceGRNNormal.value.HeadObject
  );

  const vRdxDBBranchList = useSelector(
    (state) => state.SliceDB.value.DBBranchList
  );
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  // const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [vRdxDBLocation, setLoc] = useState([]);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(2);
  const sEnterKeyObj = {
    key: "Enter",
  };

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });

  const [sRSP_MRP_Obj, setRSP_MRP_Obj] = useState({ RSP: 0, MRP: 0 });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sCurrency, setCurrency] = useState([
    {
      Uid: "",
      Name1: "",
      MainCurr: "",
      SubCurr: "",
      Rate: 1,
      SDes: "",
    },
  ]);
  const [sType, setType] = useState([]);
  const [sBuyer, setBuyer] = useState([]);
  const [sPurchaseReturnType, setPurchaseReturnType] = useState([]);

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const [sFooterObj, setFooterObj] = useState({
    A_GrossAmt: (0).toFixed(sRoundingVal),
    A_TDiscAmt: (0).toFixed(sRoundingVal),
    A_LDiscAmt: (0).toFixed(sRoundingVal),
    A_FocAmt: (0).toFixed(sRoundingVal),
    A_NetExcise: (0).toFixed(sRoundingVal),
    A_Tax: (0).toFixed(sRoundingVal),
    A_Tax2: (0).toFixed(sRoundingVal),
    A_AddCess: (0).toFixed(sRoundingVal),
    A_LandVal: (0).toFixed(sRoundingVal),
    A_SplDiscAmt1: (0).toFixed(sRoundingVal),
    netAmtFinal: (0).toFixed(sRoundingVal),
  });

  const [batchnoFieldEnable, setbatchnoFieldEnable] = useState(false);
  const [batchFlag, setbatchFlag] = useState(false);
  const [SerialDetalModal, setSerialDetalModal] = useState({
    SrNo: 0,
    ItemCd: "",
    Batch: "N",
    Serial: "N",
    AutoGrn: "N",
  });
  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [isSaveLoaded, setSaveLoaded] = useState(false);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select

  let vBufferObjInit = {
    B_Srno: 0, // int

    B_RefDocTyp: "",
    B_RefDocTypName: "",
    B_RefDocNo: "",
    SuppRefNo1: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Barcode: "",
    B_Qty: 0,

    B_Unit: "",
    B_UnitName: "",
    PalletType: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    B_URateFc: (0).toFixed(sRoundingVal), //Decimal
    B_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_GrossAmt: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_FocFlag: "N",
    B_AprmtFlag: sFocFlagArr[0],
    B_FocAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxNetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_NetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Base_Rate: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc, //Decimal
    B_TaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc, //Decimal
    B_TaxAmt2: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_CessAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCQty: (0).toFixed(sRoundingVal), //Decimal
    AddCess: (0).toFixed(sRoundingVal), //Decimal
    B_NetAddCess: (0).toFixed(sRoundingVal), //Decimal
    B_Total: (0).toFixed(sRoundingVal), //Decimal
    B_HSN: "",
    B_HighCost: "N",
    B_PR: "N",
    B_ExpDt: new Date("1900-01-01"),
    B_Narr: "",
    B_X_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_X_DiffAmt: (0).toFixed(sRoundingVal), //Decimal
    B_X_NetDiffAmt: (0).toFixed(sRoundingVal), //Decimal
    ReduceCost: "N",
    PR: "N",
    HC: "N",
    ExpDate: new Date(),
    SplDiscPerc: (0).toFixed(sRoundingVal),
    SplDiscAmt: (0).toFixed(sRoundingVal),
    SplDisc: (0).toFixed(sRoundingVal),
    Narration: "",
    //ExtraAdded
    B_LandVal: "",
    RebateType: "",

    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(sRoundingVal),
    B_OthersPerc: (0).toFixed(sRoundingVal),
    B_SLANSuprv: "",
    B_SlabAmtSuprv: (0).toFixed(sRoundingVal),
    B_SLANOther: "",
    B_SlabAmtOther: (0).toFixed(sRoundingVal),
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  //Modal

  //Reverse
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API

  const [sDiscountPercentageModal, setDiscountPercentageModal] =
    useState(false);

  const fCloseDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };

  const fOpenDiscountPercentageModal = (e) => {
    if (sDetailGridData.length > 0) {
      setDiscPerModelObj({
        A_TDiscAmt: sFooterObj.A_TDiscAmt,
        A_DiscPerc: vRdxWmsHead.A_DiscPerc,
      });
      setDiscountPercentageModal(true);
    } else {
      fAlertToast("FAILED", "save atleast one line item");
    }
  };

  const [sDiscPerModelObj, setDiscPerModelObj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxWmsHead.A_DiscPerc,
  });
  const [sErrorMsgDiscountModal, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });
  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };
  const fonChangeInputDiscountModal = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: event.target.value,
      A_TDiscAmt: vTDiscAmt,
    }));
  };

  //DiscountAmt modal
  const fOnChangeTDiscAmtModal = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: vCheckValue === 0 ? 0 : fcovertToNumber(vTDiscPer),
      A_TDiscAmt: e.target.value,
    }));
  };

  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (sDiscPerModelObj.A_DiscPerc != 0 && sDiscPerModelObj.A_TDiscAmt == 0) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      sDiscPerModelObj.A_DiscPerc == 0 &&
      sDiscPerModelObj.A_TDiscAmt != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc > 100) ||
      Number(sDiscPerModelObj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc  must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  const GetApplyTDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        v_B_VocTyp: vRdxWmsHead.A_VocTyp,
        v_B_VocNo: vRdxWmsHead.A_VocNo,
        v_TDiscPerc: parseFloat(sDiscPerModelObj.A_DiscPerc),
        v_A_DiscFlag: vRdxWmsHead.A_DiscFlag || "",
      };
      const resp = await GRNNormal_fINV03_fDiscCalc_GETROW(vApplyTDiscountObj);
      if (resp?.status === 200) {
        dispatch(
          Set_GRNNormal_HeadObject_Set({
            ...vRdxWmsHead,
            A_DiscPerc: sDiscPerModelObj.A_DiscPerc,
          })
        );
        fCloseDiscountPercentageModal();
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.TaxType
        );
        setTimeout(() => {
          document.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      }
    }
  };

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
    let { PaymodeEnable } = fDefaultPayload(vGrnType.Paymode, dispatch);
    setPaymodeEnable(PaymodeEnable);

    await fBuyreGetRow(
      vGrnType?.VocTyp,
      vRdxWmsHead?.A_VocNo,
      vRdxWmsHead?.Loc,
      vRdxDBLocation
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }
  };

  const fInvNo = (event) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_RefNo: event.target.value,
      })
    );
  };

  const fInvDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }
  };

  const fForm = (event) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        Type: event.target.value,
        A_Party: "",
        A_PartyName: "",
      })
    );
    fDiscFlagDependency(event.target.value, dispatch);
  };

  const fPaymode = (event) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_PayMode: event.target.value,
      })
    );
  };

  const fInvAmt = (event) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        VendorInvAmount: event.target.value,
      })
    );
  };
  const fPurchaseReturnType = (event) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        PurchaseReturnType: event.target.value,
      })
    );
  };

  const fTax = async (event) => {
    var vUnloading = sTax.find((option, index) => {
      return option.Uid === event.target.value;
    });
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        TaxType: vUnloading.Uid,
        A_CUSTFIELD3Name: vUnloading.Name,
        Tax:
          event.target.value == "OTTRN001" || event.target.value == "INTRN001"
            ? "Y"
            : "N",
      })
    );
    //if inter.comp then tax group should be 0
    if (vUnloading.Uid == "INTRN002" || vUnloading.Uid == "INTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE?.Val
      );
    } else {
      if (sBufferObj.B_Itmcd === "") {
        InterCompanyDependency(vRdxGRNtax1[0].UId, vRdxGRNtax2[0].UId);
      } else {
        let vItemSearchFull = await GetItemFullSearchArr(
          sBufferObj.B_Itmcd,
          vRdxWmsHead.A_Loc
        );
        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            vRdxWmsHead,
            sBufferObj,
            setBufferObj,
            setUnit,

            vRdxDBKernObj.DEF_ZERO_TAX_CODE?.Val,
            vRdxDBKernObj.DEF_ZERO_CESS_CODE?.Val,
            setRSP_MRP_Obj
          );
        }
      }
    }
  };

  const fOffer = (event) => {
    if (event.target.checked) {
      dispatch(Set_GRNNormal_HeadObject_Set({ ...vRdxWmsHead, offer: "Y" }));
    } else {
      dispatch(Set_GRNNormal_HeadObject_Set({ ...vRdxWmsHead, offer: "N" }));
    }
  };

  const fCurrency = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Curr: vCurrency.Uid,
        A_Currname: vCurrency.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vCurrency?.Rate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vRdxGRNtax1[0].Perc,
      vRdxGRNtax2[0].Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    // setsSelectedCurrency(event.target.value);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fLocation = async (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
      })
    );
    GetDefcustomersetting(
      vRdxWmsHead.Party,
      e.target.value,
      vRdxWmsHead.Type,
      dispatch
    );

    await fBuyreGetRow(
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead?.A_VocNo,
      e.target.value,
      vRdxDBLocation
    );
  };

  //GCCustomer Search

  const xfGC_Toggle_Head_Customer_Name = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_PartyName: e.target.value,
      })
    );
  };

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setItemToggleDropdown(false);
      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
      setItemToggleDropdown(false);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          vRdxWmsHead.A_PartyName,
          "Any",
          vRdxWmsHead.Type == "SALES_RETURN" ? "D" : "C",
          "N",
          dispatch
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_Customer_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        vRdxWmsHead.A_PartyName,
        "Any",
        vRdxWmsHead.Type == "SALES_RETURN" ? "D" : "C",
        "Y",
        dispatch
      );
      // let iDefaultTaxType = await GetTransTaxType(
      //   vRdxuserLoc[0].UID,
      //   vExactSearch[0]?.AcCd
      // );

      if (vExactSearch.length > 0) {
        let vDefaultTaxType = sTax[0].Uid;
        let iDefaultTaxType = await GetTransTaxType(
          vRdxWmsHead.A_Loc,
          vExactSearch[0]?.AcCd,
          dispatch
        );
        if (Object.keys(iDefaultTaxType).length != 0) {
          vDefaultTaxType = iDefaultTaxType?.TaxType;
        }
        //if inter.comp then tax group should be 0
        if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
          InterCompanyDependency(
            vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
            vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
          );
        }
        dispatch(
          Set_GRNNormal_HeadObject_Set({
            ...vRdxWmsHead,
            A_Party: vExactSearch[0]?.AcCd,
            A_PartyName: vExactSearch[0]?.Name1,
            TaxType: vDefaultTaxType,
          })
        );

        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
      if (vRdxWmsHead.A_Party != "") {
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        vRdxWmsHead.Type == "SALES_RETURN" ? "D" : "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_OnRowClick = async (e) => {
    let vDefaultTaxType = sTax[0].Uid;
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc,
      e?.row?.AcCd,
      dispatch
    );
    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
      InterCompanyDependency(
        vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
      );
    }
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        TaxType: vDefaultTaxType,
      })
    );

    xfGC_Toggle_Head_Customer_Toggle();
  };

  const fGC_Toggle_Head_Customer_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_Customer_OnRowClick(newSelectionModel);
    }
  };

  //GC CustomerSearch End
  //FOOTER FUNCTION
  const fBuyer = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Buyer: e.target.value,
      })
    );
  };
  const fFreight = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_LC: e.target.value,
      })
    );
  };

  const fFreight_onFocus = (e) => {
    if (vRdxWmsHead.A_LC == 0) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_LC: "",
        })
      );
    }
  };
  const fFreight_onBlur = (e) => {
    if (vRdxWmsHead.A_LC == "") {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_LC: 0,
        })
      );
    }
  };

  const fCustomer = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Charges1: e.target.value,
      })
    );
  };
  const fCustomer_onFocus = (e) => {
    if (vRdxWmsHead.A_LC == 0) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_Charges1: "",
        })
      );
    }
  };
  const fCustomer_onBlur = (e) => {
    if (vRdxWmsHead.A_LC == "") {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_Charges1: 0,
        })
      );
    }
  };

  const fLoadedCost = (e) => {
    if (
      e._reactName == "onClick" &&
      vRdxWmsHead.A_VocNo != 0 &&
      !!vRdxWmsHead.A_VocNo
    ) {
      fOpenLandedCostModal();
    }
  };

  const fHeadNarration = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) +
      // fcovertToNumber(sFooterObj.A_SplDiscAmt1) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      // fcovertToNumber(sFooterObj.A_Tax) +
      // fcovertToNumber(sFooterObj.A_Tax2) +
      // fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));
    let netAmtFinal =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      // iSplDiscAmt1 +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(2),
      netAmtFinal: netAmtFinal.toFixed(2),
    }));
  };

  const fFooter_Rounding_Blur = (e) => {
    const iRounding = fcovertToNumber(e.target.value);
    if (iRounding == 0) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: (0).toFixed(4),
        })
      );
      fLandValueCalc(e);
    }
  };

  const fFooter_Rounding_Focus = (e) => {
    if (e.target.value == 0) {
      dispatch(
        Set_GRNNormal_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: "",
        })
      );
    }
  };

  const fRounding = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_Rounding: e.target.value,
      })
    );
    fLandValueCalc(e);
  };

  const fDiscFlag = (e) => {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_DiscFlag: e.target.checked ? "Y" : "N",
      })
    );
  };

  //DETAIL  FUNCTION

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  const fUnit = async (e) => {
    let vSelectedObj = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vSelectedObj?.Unit,
      B_UnitName: vSelectedObj?.Name1,
      B_PackQty: vSelectedObj?.PackQty,
    }));

    await Unit_Onchange_001(
      vSelectedObj?.Unit,
      vSelectedObj,
      sBufferObj.B_Itmcd,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      setBufferObj,
      setRSP_MRP_Obj
    );
  };

  const fUnitRate = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: e.target.value,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      Number(e.target.value),
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc,
      Number(event.target.value),
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_URateFc,
    }));
  };

  const fUnitRateSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };

  const fFoc = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_FocFlag: e.target.checked ? "Y" : "N",
    }));
    let isChecked = e.target.checked ? "Y" : "N";
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      isChecked,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fFocFlag = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_AprmtFlag: e.target.value,
    }));
  };

  const fExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxAmt: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      e.target.value,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fNetExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxNetAmt: e.target.value,
    }));
  };

  const fTaxGroup = (e) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept: vtaxGroupValue?.UId,
      B_TaxPerc: vtaxGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };
  //if inter.comp then tax group should be 0
  const InterCompanyDependency = (xTaxID, xCessID) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == xTaxID;
    });
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == xCessID;
    });
    if (vtaxGroupValue) {
      setBufferObj((obj) => ({
        ...obj,
        B_TaxDept: vtaxGroupValue?.UId,
        B_TaxPerc: vtaxGroupValue?.Perc,
        B_TaxDept2: vCessGroupValue?.UId,
        B_TaxPerc2: vCessGroupValue?.Perc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
    return {
      B_TaxPerc: vtaxGroupValue?.Perc,
      B_TaxPerc2: vCessGroupValue?.Perc,
    };
  };
  const fCessGroup = (e) => {
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept2: vCessGroupValue?.UId,
      B_TaxPerc2: vCessGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fType = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      RebateType: e.target.value,
      SplDiscPerc: 0,
      SplDiscAmt: 0,
    }));
    if (e.target.value == "" || e.target.value == "Linewise Rebate") {
      setBufferObj((obj) => ({
        ...obj,
        ReduceCost: "N",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        ReduceCost: "Y",
      }));
    }
  };

  const fDiscPer = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      SplDiscPerc: e.target.value,
    }));

    if (!!e.target.value && sBufferObj.B_GrossAmt != 0) {
      let DiscAmt =
        (fcovertToNumber(e.target.value) / 100) *
        fcovertToNumber(sBufferObj.B_GrossAmt);
      setBufferObj((obj) => ({
        ...obj,
        SplDiscAmt: DiscAmt.toFixed(sRoundingVal),
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        SplDiscAmt: Number(0),
      }));
    }
  };

  const fDiscAmt = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      SplDiscAmt: e.target.value,
    }));
    if (!!e.target.value && sBufferObj.B_GrossAmt != 0) {
      let DiscPerc =
        (fcovertToNumber(e.target.value) * 100) /
        fcovertToNumber(sBufferObj.B_GrossAmt);
      setBufferObj((obj) => ({
        ...obj,
        SplDiscPerc: DiscPerc.toFixed(4),
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        SplDiscPerc: 0,
      }));
    }
  };

  const fLDiscPer = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscPerc: e.target.value,
    }));
    if (e.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate,
        sBufferObj.B_URateFc,
        e.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0,
        sBufferObj.SplDiscPerc
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_LDiscPerc,
    }));
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      e.target.value == "" ? 0 : e.target.value,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };
  const fQtyEnter = (e) => {
    if (e.key === "Enter" && vRdxWmsHead.A_DocStat == "ENTER") {
      document.getElementsByName("B_Qty")[0]?.blur();
      fSave();
    }
  };

  const fNetAmt = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_NetAmt: e.target.value,
    }));
  };

  const fNarration = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e.target.value,
    }));
  };

  const fReduceCost = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      ReduceCost: e.target.checked ? "Y" : "N",
    }));
  };
  const fCheckbox = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.checked ? "Y" : "N",
    }));
  };
  const fExpDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        ExpDate: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        ExpDate: e?.$d,
      }));
    }
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_Loc
      );
      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit,

          vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
          vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val,
          setRSP_MRP_Obj
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0].Perc, //tax1%
        vRdxGRNtax2[0].Perc, //tax%2
        0, //sBufferObj.AddCess,
        0, //Rounding,
        0 //splDisPer
      );
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        SuppRefNo1: "",
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      }));
      setRSP_MRP_Obj({ RSP: 0, MRP: 0 });
      setUnit([]);
    }
  };

  //MODAL HEAD
  const [sRefDocSearchModal, setRefDocSearchModal] = useState(false);
  const [sRefInboundGridData, setRefDocModalArr] = useState([]);

  const [sRefDocModelObj, setRefDocModelObj] = useState({
    AnyData: vRdxWmsHead?.A_RefDocNo,
    Name: "",
    Code: "",
  });

  const fRefDocClearSimpleSearch = () => {
    setRefDocModelObj(vHeaderSearchInit);
    setRefDocModalArr([]);
  };

  const fOpenRefDocSearchModal = () => {
    setRefDocModelObj((obj) => ({
      ...obj,
      AnyData: vRdxWmsHead?.A_RefDocNo,
    }));
    setRefDocSearchModal(true);
  };

  // if anydata value != "" call API
  //GCSimpleSearch

  const fRefDocSearchEnter = async (e) => {
    if (e.key === "Enter") {
      let srcDocNoArr = await GetRefDocInbound(
        sRefDocModelObj?.AnyData,
        sRefDocModelObj.Code,
        sRefDocModelObj.Name,
        setRefDocModalArr
      );
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };

  const fonChangeRefDocModal = (event) => {
    setRefDocModelObj({
      ...sRefDocModelObj,
      [event.target.name]: event.target.value,
    });
  };

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit,

        vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val,
        setRSP_MRP_Obj
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal GCSearchBtn
  const [sSearchLoactionArr, setSearchLoactionArr] = useState(vRdxDBLocation);
  // const addAllInSearchLoactionArr = () => {
  //   const newObj = {
  //     UID: " ",
  //     Name1: " ",
  //     BranchCode: "",
  //     BranchName: " ",
  //   };

  //   // Use the spread operator to create a new array with the new object added at the beginning
  //   setSearchLoactionArr([newObj, ...sSearchLoactionArr]);
  // };
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: "",
    RefNo: "",
    SalesGroup: "",
    Party: "All",
    PartyName: "All",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    document.getElementById("IdSearch")?.blur();
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW
    let iSalesGroupArr = await GetSalesGroupSearch(vRdxWmsHead.A_Loc);
    if (iSalesGroupArr.length > 0) {
      setGCSeachSalesGroupSearch(iSalesGroupArr);
      // addAllInSearchLoactionArr();
      setSearchModalObj({
        ...sSearchModalObj,
        SalesGroup: iSalesGroupArr[0]?.UId,
      });
      GetSearchValue("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
    setTimeout(() => {
      document.getElementsByName("VocNo")[0]?.focus();
    }, 100);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  //if GRNDocTyp, GrnDocNo is not empty then it is from notification page
  // so redirect to notification page in mobile screen
  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: "",
      RefNo: "",
      SalesGroup: sGCSeachSalesGroupSearch[0]?.UId,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearchBtn
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(
      e?.row?.A_VocTyp,
      e?.row?.A_VocNo,
      dispatch,
      fNewDetail,
      fBuyreGetRow
    );
    fCloseSearchModal();
  };
  //GCSearchBtn
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
    }
  };

  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sSearchModalObj.PartyName,
      }));
      if (sSearchModalObj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match

      if (sSearchModalObj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          GetSearchValue(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document?.getElementsByClassName("Mui-selected")?.length;
        if (selectedLength === 0) {
          let tabel = document?.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 500);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GetSearchValue("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };
  const fGCSearchBtn_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCSearchBtn_OnRowClick(newSelectionModel);
    }
  };
  //GCSearchBtn End

  // Stock Setup Change - Request Modal
  const [stockSetupChangeReqModal, setStockSetupChangeReqModal] =
    useState(false);
  const [selectedItemData, setselectedItemData] = useState(null);

  const xGCStockSetupChangeReq = (e, row) => {
    e.preventDefault();
    setselectedItemData(row);
    setStockSetupChangeReqModal(true);

    setTimeout(() => {
      document.getElementById("naration")?.focus();
    }, 500);
  };

  const xGCStockSetupChangeReqClose = () => {
    setStockSetupChangeReqModal(false);
  };

  const fStockSetupRequestModal = (ItemCd, ItemName, errorMsg) => {
    confirmAlert({
      title: "Save",
      message: ` ${errorMsg}! Are you sure you want to save?`,
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            setselectedItemData({ B_Itmcd: ItemCd, ItmName: ItemName });
            setStockSetupChangeReqModal(true);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            // You can add additional logic here if needed
          },
        },
      ],
    });
  };
  // StockSetupChangReq Modal end

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALL", vSelectedValue);
  };
  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // if (new Date(event.target.value) > new Date("01/01/1990")) {
    //   GetSearchValue("", "APICALLDATE", changedDate);
    // }
  };
  const fonChangePartyModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
    }));
    GetSearchValue("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const fonChangeLocModal = (event, selectArr) => {
    // var vSelectedValue = selectArr?.find((obj, index) => {
    //   return obj.UID == event.target.value;
    // });
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   Loc: vSelectedValue.UID,
    // }));
    // GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
    var vSelectedValue = selectArr?.find((obj) => {
      const firstKey = Object.keys(obj)[0];
      return obj[firstKey] == event.target.value;
    });

    if (vSelectedValue) {
      const firstKey = Object.keys(vSelectedValue)[0]; // Get the first key again
      const firstKeyValue = vSelectedValue[firstKey];

      setSearchModalObj((obj) => ({
        ...obj,
        Loc: firstKeyValue,
      }));

      GetSearchValue("", "APICallLocModal", firstKeyValue);
    }
  };

  const fonChangeSalesGroupModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      SalesGroup: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallSalesGroupModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        v_TrnTyp: sTrnTyp,
        v_VocNo: sSearchModalObj.VocNo,
        v_PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("MM/DD/YYYY")
            : !!sSearchModalObj.PostDt
            ? moment(sSearchModalObj.PostDt).format("MM/DD/YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        v_RefNo: sSearchModalObj.RefNo,
        v_Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!sSearchModalObj.Party
            ? sSearchModalObj.Party
            : "All",
        v_Type: "",
        v_Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        v_Status: xAPICALL === "APICALL" ? xSTATUS : sSearchModalObj.Status,
        v_UserCd: vRdxuserInfo.UserID,
      };
      const resp = await GRNNormal_INV03_Search_GETROW(vSearchObj);
      if (resp?.status === 200) {
        let vSearchArr = resp?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      }
    }
    // if (e.key == "ArrowDown" || e.keyCode == 40) {
    //   setTimeout(() => {
    //     var selectedLength =
    //       document?.getElementsByClassName("Mui-selected")?.length;
    //     if (selectedLength === 0) {
    //       let tabel = document?.getElementById("table-main-grid-4");
    //       tabel
    //         ?.getElementsByClassName("MuiDataGrid-row")[0]
    //         ?.firstChild?.focus();

    //       // let tabel = document.getElementById("table-main-grid-4");
    //       //       tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild.click();
    //       //       tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.focus();
    //     }
    //   }, 500);
    // }
  };

  //API SALESGROUP
  const GetSalesGroupSearch = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs.Type == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast("FAILED", vSalesGroupSearchs.Message);
    }
  };
  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };
  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = GRNNormalRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );
    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //PendingPo start
  const [sPendingPoModal, setPendingPoModal] = useState(false);
  const [sPendingPoData, setPendingData] = useState(false);

  const fOpenPendingPoModal = () => {
    setPendingPoModal(true);
  };
  const fPendingPo = async (e) => {
    const { HeadObject } = GRNNormalRo();
    await GetPengingPo(
      HeadObject.A_RefDocNo,
      HeadObject.A_RefDocTyp,
      setPendingData
    );
    fOpenPendingPoModal();
  };
  const fClosePendingPoModal = (e) => {
    setPendingPoModal(false);
  };
  //PendingStock end
  //Pallet start
  const [sPalletModal, setPalletModal] = useState(false);
  const [sPalletData, setPalletData] = useState([]);

  const fOpenPalletModal = () => {
    setPalletModal(true);
  };
  const fPallet = async (e) => {
    const { HeadObject } = GRNNormalRo();
    await GetPallet(
      HeadObject.A_RefDocNo,
      HeadObject.A_RefDocTyp,
      setPalletData
    );
    fOpenPalletModal();
  };
  const fClosePalletModal = (e) => {
    setPalletModal(false);
  };
  //PendingStock end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = GRNNormalRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //MSPUpdate start
  const [sMSPUpdateModal, setMSPUpdateModal] = useState(false);
  const [sGridDataMSPUpdateRows, setGridDataMSPUpdateRows] = useState([]);
  const [sGridDataMSPUpdateColumns, setGridDataMSPUpdateColumns] = useState([
    {
      field: "ItmCd",
      headerName: "Item.Code",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ItemName",
      headerName: "Item.Name",
      hide: false,
      width: 210,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_LOC",
      headerName: "A_LOC",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_unit",
      headerName: "B_unit",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      hide: false,
      width: 60,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "TaxDept",
      headerName: "Tax Dept",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "StkQty",
      headerName: "Stock",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TaxPerc",
      headerName: "TaxPerc",
      hide: true,
      width: 80,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "CostPr",
      headerName: "Cost.Pr",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "SellPr1",
      headerName: "RSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TAXRSP",
      headerName: "VAT.RSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "GPPerc",
      headerName: "GP.%",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "MSP",
      headerName: "MSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "MSPGPPerc",
      headerName: "MSP.GP%",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TSROH",
      headerName: "OH",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
  ]);
  const fOpenMSPUpdateModal = () => {
    setMSPUpdateModal(true);
  };
  const fMSPUpdate = async (e) => {
    const { HeadObject } = GRNNormalRo();
    await GetMSPUpdate(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataMSPUpdateRows
    );
    fOpenMSPUpdateModal();
  };
  const fCloseMSPUpdateModal = (e) => {
    setMSPUpdateModal(false);
  };
  //MSPUpdate end

  //GCLandedCost

  const [sLandedCostModal, setLandedCostModal] = useState(false);
  const [sLandedCostDiscAmt, setLandedCostDiscAmtModal] = useState(0);
  const [sLandedCostObjModal, setLandedCostObjModal] = useState({
    Loaded_Cost_Freight_Acc: sLoadedCostAccountArr[0],
    Loaded_Cost_Freight_Code: "",
    Loaded_Cost_Freight_Name: "",
    Loaded_Cost_Customs_Acc: sLoadedCostAccountArr[0],
    Loaded_Cost_Customs_Code: "",
    Loaded_Cost_Customs_Name: "",
    Loaded_Cost_Discount_Code: "",
    Loaded_Cost_Discount_Name: "",
    Loaded_Cost_SplDiscount_Code: "",
    Loaded_Cost_SplDiscount_Name: "",
  });

  const [sLandedCostObjError, setLandedCostObjError] = useState({
    Loaded_Cost_Freight_Acc: "",
    Loaded_Cost_Freight_Code: "",
    Loaded_Cost_Freight_Name: "",
    Loaded_Cost_Customs_Acc: "",
    Loaded_Cost_Customs_Code: "",
    Loaded_Cost_Customs_Name: "",
    Loaded_Cost_Discount_Code: "",
    Loaded_Cost_Discount_Name: "",
    Loaded_Cost_SplDiscount_Code: "",
    Loaded_Cost_SplDiscount_Name: "",
  });
  const fOpenLandedCostModal = async () => {
    const { SplDiscAmt1 } =
      sDetailGridData.length > 0
        ? sDetailGridData.reduce(
            (iValue, item) => {
              iValue.SplDiscAmt1 += item?.SplDiscAmt1;
              return iValue;
            },
            { SplDiscAmt1: 0 }
          )
        : { iSplDiscAmt: 0 };
    setLandedCostDiscAmtModal(SplDiscAmt1);
    // WMINV03D_GetRow
    let iLoadecCostRecset = await Get_Loaded_Cost_WMINV03D_GetRow(dispatch);
    if (iLoadecCostRecset.length > 0) {
      let iFreight = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "FREIGHT"
      );
      if (!!iFreight) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Acc:
            iFreight.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Freight_Code: iFreight.D_CrAc,
          Loaded_Cost_Freight_Name: iFreight.D_CrAcName,
        }));
      }
      let iCustoms = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "CHARGES"
      );
      if (!!iCustoms) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Acc:
            iCustoms.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Customs_Code: iCustoms.D_CrAc,
          Loaded_Cost_Customs_Name: iCustoms.D_CrAcName,
        }));
      }
      let iDiscount = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "DISCOUNT"
      );
      if (!!iDiscount) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Acc:
            iDiscount.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Discount_Code: iDiscount.D_CrAc,
          Loaded_Cost_Discount_Name: iDiscount.D_CrAcName,
        }));
      }
      let iSplDiscount = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "SPLDISCOUNT"
      );
      if (!!iSplDiscount) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Acc:
            iSplDiscount.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_SplDiscount_Code: iSplDiscount.D_CrAc,
          Loaded_Cost_SplDiscount_Name: iSplDiscount.D_CrAcName,
        }));
      }
    }
    setLandedCostModal(true);
  };
  const fCloseLandedCostModal = (e) => {
    setLandedCostObjModal({
      Loaded_Cost_Freight_Acc: sLoadedCostAccountArr[0],
      Loaded_Cost_Freight_Code: "",
      Loaded_Cost_Freight_Name: "",
      Loaded_Cost_Customs_Acc: sLoadedCostAccountArr[0],
      Loaded_Cost_Customs_Code: "",
      Loaded_Cost_Customs_Name: "",
      Loaded_Cost_Discount_Code: "",
      Loaded_Cost_Discount_Name: "",
      Loaded_Cost_SplDiscount_Code: "",
      Loaded_Cost_SplDiscount_Name: "",
    });
    setLandedCostModal(false);
    setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    setLoaded_Cost_Freight_ToggleDropDowm(false);
    setLoaded_Cost_Customs_ToggleDropDowm(false);
    setLoaded_Cost_Discount_ToggleDropDowm(false);
    setLandedCostObjError(Loaded_Cost_Freight_Init);
  };

  //freight
  const xfLoaded_Cost_Freight_Acc = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Acc: e.target.value,
      Loaded_Cost_Freight_Code: "",
      Loaded_Cost_Freight_Name: "",
    }));
  };
  const xfLoaded_Cost_Freight_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Freight_SearchDropdownObj,
    setLoaded_Cost_Freight_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Freight_GridData, setLoaded_Cost_Freight_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Freight_ToggleDropDowm,
    setLoaded_Cost_Freight_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Freight_Toggle = useCallback(() => {
    if (sLoaded_Cost_Freight_ToggleDropDowm) {
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Freight_GridData([]);
      setLoaded_Cost_Freight_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Freight_ToggleDropDowm(true);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Freight_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Freight_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Freight_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Freight_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Freight_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Freight_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Freight_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Freight_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Freight_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Freight_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Freight_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Freight_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Freight_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Freight_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Freight_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Freight_Dropdown_onChange = (e) => {
    setLoaded_Cost_Freight_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Freight_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Freight_SearchDropdownObj.Data,
        sLoaded_Cost_Freight_SearchDropdownObj.Type,
        sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Freight_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Freight_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Freight_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Code: e?.row?.AcCd,
      Loaded_Cost_Freight_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_Freight_Toggle();
  };
  const fLoaded_Cost_Freight_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Freight_OnRowClick(newSelectionModel);
    }
  };
  //Customs

  const xfLoaded_Cost_Customs_Acc = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Acc: e.target.value,
      Loaded_Cost_Customs_Code: "",
      Loaded_Cost_Customs_Name: "",
    }));
  };
  const xfLoaded_Cost_Customs_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Customs_SearchDropdownObj,
    setLoaded_Cost_Customs_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Customs_GridData, setLoaded_Cost_Customs_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Customs_ToggleDropDowm,
    setLoaded_Cost_Customs_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Customs_Toggle = useCallback(() => {
    if (sLoaded_Cost_Customs_ToggleDropDowm) {
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Customs_GridData([]);
      setLoaded_Cost_Customs_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Customs_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Customs_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Customs_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Customs_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Customs_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Customs_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Customs_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Customs_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Customs_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Customs_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Customs_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Customs_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Customs_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Customs_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Customs_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Customs_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Customs_Dropdown_onChange = (e) => {
    setLoaded_Cost_Customs_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Customs_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Customs_SearchDropdownObj.Data,
        sLoaded_Cost_Customs_SearchDropdownObj.Type,
        sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Customs_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Customs_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Customs_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Code: e?.row?.AcCd,
      Loaded_Cost_Customs_Name: e?.row?.Name2,
    }));

    xfLoaded_Cost_Customs_Toggle();
  };
  const fLoaded_Cost_Customs_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Customs_OnRowClick(newSelectionModel);
    }
  };

  //Discount

  const xfLoaded_Cost_Discount_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Discount_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Discount_SearchDropdownObj,
    setLoaded_Cost_Discount_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Discount_GridData, setLoaded_Cost_Discount_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Discount_ToggleDropDowm,
    setLoaded_Cost_Discount_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Discount_Toggle = useCallback(() => {
    if (sLoaded_Cost_Discount_ToggleDropDowm) {
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_Discount_GridData([]);
      setLoaded_Cost_Discount_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Discount_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Discount_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Discount_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Discount_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Discount_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Discount_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Discount_Name,
          "Any",
          "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Discount_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Discount_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Discount_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Discount_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Discount_Name,
          "Any",
          "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Discount_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Discount_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Discount_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Discount_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Discount_Dropdown_onChange = (e) => {
    setLoaded_Cost_Discount_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Discount_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Discount_SearchDropdownObj.Data,
        sLoaded_Cost_Discount_SearchDropdownObj.Type,
        "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Discount_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Discount_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Discount_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Discount_Code: e?.row?.AcCd,
      Loaded_Cost_Discount_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_Discount_Toggle();
  };
  const fLoaded_Cost_Discount_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Discount_OnRowClick(newSelectionModel);
    }
  };
  //SplDiscount

  const xfLoaded_Cost_SplDiscount_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_SplDiscount_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_SplDiscount_SearchDropdownObj,
    setLoaded_Cost_SplDiscount_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [
    sLoaded_Cost_SplDiscount_GridData,
    setLoaded_Cost_SplDiscount_GridData,
  ] = useState([]);
  const [
    sLoaded_Cost_SplDiscount_ToggleDropDowm,
    setLoaded_Cost_SplDiscount_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_SplDiscount_Toggle = useCallback(() => {
    if (sLoaded_Cost_SplDiscount_ToggleDropDowm) {
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_GridData([]);
      setLoaded_Cost_SplDiscount_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_SplDiscount_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_SplDiscount_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_SplDiscount_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_SplDiscount_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
          "Any",
          "K",
          "N",
          dispatch
        );
        setLoaded_Cost_SplDiscount_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_SplDiscount_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_SplDiscount_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
          "Any",
          "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_SplDiscount_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_SplDiscount_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_SplDiscount_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_SplDiscount_Code: "",
      }));
    }
  };

  const fLoaded_Cost_SplDiscount_Dropdown_onChange = (e) => {
    setLoaded_Cost_SplDiscount_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_SplDiscount_SearchDropdownObj.Data,
        sLoaded_Cost_SplDiscount_SearchDropdownObj.Type,
        "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_SplDiscount_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_SplDiscount_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fLoaded_Cost_SplDiscount_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_SplDiscount_Code: e?.row?.AcCd,
      Loaded_Cost_SplDiscount_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_SplDiscount_Toggle();
  };

  const fLoaded_Cost_SplDiscount_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_SplDiscount_OnRowClick(newSelectionModel);
    }
  };

  const fLoaded_Cost_Validation = () => {
    let iResp = true;
    if (vRdxWmsHead.A_LC > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Freight_Acc === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Acc: " Freight account should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Freight_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Code: " Freight code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Freight_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Name: " Freight name should not be empty",
        }));
        iResp = false;
      }
    }
    if (vRdxWmsHead.A_Charges1 > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Customs_Acc === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Acc: " Customs account should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Customs_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Code: " Customs code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Customs_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Name: " Customs name should not be empty",
        }));
        iResp = false;
      }
    }
    let idiscount = vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt;
    if (idiscount > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Discount_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Code: " Discount code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Discount_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Name: " Discount name should not be empty",
        }));
        iResp = false;
      }
    }
    if (sLandedCostDiscAmt > 0) {
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Code: " SplDiscount code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Name: " SplDiscount name should not be empty",
        }));
        iResp = false;
      }
    }
    return iResp;
  };
  const fLoaded_Cost_Save = async () => {
    setLandedCostObjError(Loaded_Cost_Freight_Init);
    let vLoadedCostArr = [
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "Freight",
        CrAc: sLandedCostObjModal.Loaded_Cost_Freight_Code,
        CrAcTyp:
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_LC,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "CHARGES",
        CrAc: sLandedCostObjModal.Loaded_Cost_Customs_Code,
        CrAcTyp:
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_Charges1,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "DISCOUNT",
        CrAc: sLandedCostObjModal.Loaded_Cost_Discount_Code,
        CrAcTyp: "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "SPLDISCOUNT",
        CrAc: sLandedCostObjModal.Loaded_Cost_SplDiscount_Code,
        CrAcTyp: "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: sLandedCostDiscAmt,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
    ];
    let vLoadedCostObj = {
      ItemList: vLoadedCostArr,
      v_D_VocTyp: vRdxWmsHead.A_VocTyp,
      v_D_VocNo: vRdxWmsHead.A_VocNo,
    };
    let iValidationLoadedCost = fLoaded_Cost_Validation();
    if (!iValidationLoadedCost) return;

    const vLoadedCostRec = await GRNNormal_FreightUpdate_GETROW(vLoadedCostObj);
    if (vLoadedCostRec.status === 200) {
      console.log(vLoadedCostRec);
    }
  };

  //GCLandedCost end

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", vTransAuditObj);
    if (vTransAudit.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };
  //Modal Batch
  const [sBatchModal, setBatchModal] = useState(false);
  const [sBatch_Total_Qty, setBatch_Total_Qty] = useState(0);
  const [sBatchDetailErrorMsg, setBatchDetailErrorMsg] = useState(
    BatchDetail_ErrorMsg_Init
  );

  const [sBatchObj, setBatchObj] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Qty: 0,
    Unit: "",
    BaseQty: 0,
  });
  const [sBatchUnit, setBatchUnit] = useState([]);
  const [sBatchCurrentEditQty, setBatch_Edit_BaseQty] = useState(0);
  const [sBatch_Load_GridData, setBatch_Load_GridData] = useState([]);
  const [sBatchDetailObj, setBatchDetailObj] = useState({
    BatchDetail_SrNo: 0, //rowId
    BatchDetail_BatchNo: 0,
    BatchDetail_MFDate: new Date(),
    BatchDetail_ExpDate: new Date(),
    BatchDetail_Qty: 1,
    BatchDetail_Unit: "",
    BatchDetail_PackQty: 0,
    BatchDetail_BaseQty: 0,
    BatchDetail_BalanceQty: 0,
  });
  const fOpenBatchModal = (xSrno, xBaseQty, xPackQty) => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);

    fBatch_Load_Grid(xSrno, xBaseQty, xPackQty);
    setBatchModal(true);
    setTimeout(() => {
      document.getElementsByName("BatchDetail_BatchNo")[0]?.focus();
    }, 100);
  };

  const fBatch_CloseModal = (e) => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);

    setBatchModal(false);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo: SerialDetalModal.Batch == "Y" ? 0 : "",
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 1,
      BatchDetail_Unit: "",
      BatchDetail_PackQty: "",
    }));
    setBatchObj({
      SrNo: 0,
      ItemCode: "",
      ItemName: "",
      Qty: 0,
      Unit: "",
      BaseQty: 0,
    });
    setBatchUnit([]);
    setBatch_Load_GridData([]);
    setBatch_Total_Qty(0);
    setBatch_Edit_BaseQty(0);
    fNewDetail(
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead.A_Rounding,
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_TaxType
    );
  };

  const fBatch_New = () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);

    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo: SerialDetalModal.Batch == "Y" ? 0 : "",
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 1,
      BatchDetail_Unit: sBatchUnit[0]?.Unit || "",
      BatchDetail_PackQty: sBatchUnit[0]?.PackQty || "",
    }));
    fBatch_BaseQty_Calculation(1, sBatchUnit[0].PackQty);

    if (sTrnTyp == "INV03" && batchFlag && SerialDetalModal.Batch == "Y") {
      setbatchnoFieldEnable(true);
    }
    fBatch_Load_Grid(sBatchObj.SrNo, sBatchObj.BaseQty, sBatchUnit[0].PackQty);
    setBatch_Edit_BaseQty(0);
    setTimeout(() => {
      document.getElementsByName("BatchDetail_BatchNo")[0]?.focus();
    }, 100);
  };

  const fBatch_Delete = async () => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fBatch_Delete2();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  const fBatch_Delete2 = async () => {
    let iBatchDelete = await GetDeleteDetailBatch(
      sBatchObj.SrNo,
      sBatchDetailObj.BatchDetail_SrNo,
      dispatch
    );
    if (!!iBatchDelete) {
      fBatch_New();
    }
  };

  const fBatch_Save = async () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    let iValidationBatch = fValidationBatch_Client(
      sBatchDetailObj,
      setBatchDetailErrorMsg,
      SerialDetalModal
    );
    if (!iValidationBatch) return;

    if (
      Number(sBatchDetailObj.BatchDetail_BalanceQty) -
        Number(sBatchDetailObj.BatchDetail_Qty) <
      0
    ) {
      fAlertToast(
        "FAILED",
        "You are trying to save excess batch qty then purchase qty (Avl qty =" +
          sBatchDetailObj.BatchDetail_BalanceQty +
          ")"
      );
    } else {
      let iBatchSave = await GetSaveDetailBatch(
        sBatchObj,
        sBatchDetailObj,
        dispatch
      );
      if (!!iBatchSave) {
        fBatch_New();
      }
    }
  };
  const fBatch_Load_Grid = async (xSrNo, xBaseQty, xPackQty) => {
    let iBatchLoadGrid = await GetBatchDetail(xSrNo, dispatch);
    if (iBatchLoadGrid.length > 0) {
      let GridID = iBatchLoadGrid?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));

      setBatch_Load_GridData(GridID);
      if (sTrnTyp == "INV03" && batchFlag && SerialDetalModal.Batch == "Y") {
        setBatchDetailObj((obj) => ({
          ...obj,
          BatchDetail_BatchNo: SerialDetalModal.Batch == "Y" ? 0 : "",
        }));
      }

      const { iTotalQty } = iBatchLoadGrid.reduce(
        (iValue, item) => {
          iValue.iTotalQty += item.C_BaseQty;
          return iValue;
        },
        { iTotalQty: 0 }
      );
      setBatch_Total_Qty(iTotalQty);
      fBatch_BalanceQty_Calculation(xBaseQty, iTotalQty, xPackQty, 0);
    } else {
      setBatch_Load_GridData([]);
      setBatch_Total_Qty(0);
      fBatch_BalanceQty_Calculation(xBaseQty, 0, xPackQty, 0);
    }
  };

  const fBatch_RowClick_Load_Grid = (item) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: item.row.C_RowId, //rowId
      BatchDetail_BatchNo: item.row.C_BatchNo,
      BatchDetail_MFDate: moment(item.row.C_BatchDt, "DD/MM/YYYY")._d,
      BatchDetail_ExpDate: moment(item.row.C_ExpDt, "DD/MM/YYYY")._d,
      BatchDetail_Qty: item.row.C_Qty,
      BatchDetail_Unit: item.row.C_Unit,
      BatchDetail_BaseQty: item.row.C_BaseQty,
    }));
    setBatch_Edit_BaseQty(Number(item.row.C_BaseQty));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === item.row.C_Unit;
    });
    let currentPackQty = sBatchUnit[0].PackQty;
    if (!!vItemUnitSet) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Unit: vItemUnitSet.Unit,
        BatchDetail_PackQty: vItemUnitSet?.PackQty,
      }));
      currentPackQty = vItemUnitSet?.PackQty;
    }
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      currentPackQty,
      item.row.C_BaseQty
    );
  };

  const fBatch_BalanceQty_Calculation = (
    xBaseQty = 0,
    xTotalQty = 0,
    xPackQty = 0,
    xExistingQty = 0
  ) => {
    let vBalanceQty =
      Number(xPackQty) === 0
        ? 0
        : (fcovertToNumber(xBaseQty) +
            fcovertToNumber(xExistingQty) -
            fcovertToNumber(xTotalQty)) /
          fcovertToNumber(xPackQty);

    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BalanceQty: vBalanceQty,
    }));
    return vBalanceQty;
  };

  const fBatch_BaseQty_Calculation = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BaseQty: vBaseQty,
    }));

    return vBaseQty;
  };

  const fBatch_MFDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_MFDate: e.$d,
    }));
  };

  const fBatch_ExpDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_ExpDate: e.$d,
    }));
  };

  const fBatch_BatchNo = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BatchNo: e.target.value,
    }));
  };
  const fBatch_Qty = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Qty: e.target.value,
    }));
    fBatch_BaseQty_Calculation(
      Number(e.target.value),
      sBatchDetailObj.BatchDetail_PackQty
    );
  };
  const fBatch_Focus_Qty = (e) => {
    if (e.target.value == 0) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: "",
      }));
    }
  };

  const fBatch_Blur_Qty = (e) => {
    if (e.target.value === "") {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: 0,
      }));
    }
  };

  const fBatch_Unit = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: e.target.value,
    }));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_PackQty: vItemUnitSet?.PackQty,
    }));
    fBatch_BaseQty_Calculation(
      sBatchDetailObj.BatchDetail_Qty,
      vItemUnitSet?.PackQty
    );
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      vItemUnitSet?.PackQty,
      sBatchCurrentEditQty
    );
  };
  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail,
      fBuyreGetRow
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo,
      dispatch,
      fNewDetail,
      fBuyreGetRow
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        fBuyreGetRow
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        fBuyreGetRow
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fPrint = useCallback(
    (xPrnTyp) => {
      let vrdl = vRdxDBBranchList.find((obj) => {
        return obj.LocName[0] == vRdxWmsHead.A_Loc;
      });
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;

      //  /WMS/GRN?trntyp=WMINV03&voctyp=WS001&vocno=WS/0000001&prntyp=PC
      // /WMS/TransGRN?trntyp=INV03&voctyp=GR001&vocno=2400000017&prntyp=p
      if (vrdl?.InvoiceFile != "") {
        let urlPrint =
          webReport?.Val +
          "WMS/TransGRN?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      } else {
        let urlPrint =
          webReport?.Val +
          "WMS/GRN?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp +
          "&amountInWord=''";
        setWebReportUrlModal(urlPrint);
        fWebReport();
        console.log(urlPrint);
      }
    },
    [
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead.A_VocTyp,
      vRdxDBKernObj,
      vRdxDBBranchList,
    ]
  );

  const SaveINV03 = async (xSave, xDocStatus = "POST") => {
    const { HeadObject } = GRNNormalRo();
    const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
    let iBr = vRdxDBLocation.find((item) => item.UId == HeadObject.A_Loc);
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("YYYY-MM-DD"),
      v_A_RefDt: moment(HeadObject.A_RefDt).format("YYYY-MM-DD"),
      v_A_RefNo: HeadObject.A_RefNo,
      v_A_Party: HeadObject.A_Party,
      v_A_Curr: HeadObject.A_Curr,
      v_A_ExRate: parseFloat(HeadObject.A_ExRate),
      v_A_PayMode: HeadObject.A_PayMode,
      v_A_Type: HeadObject.A_Type,
      v_A_Br: iBr?.Br,
      v_A_Loc: HeadObject.A_Loc,
      v_A_Buyer: HeadObject.A_Buyer,
      v_A_Narr: HeadObject.A_Narr,
      v_A_CrAc: "",
      v_A_DrAc: "",
      v_A_DiscPerc: parseFloat(HeadObject.A_DiscPerc),
      v_A_DiscFlag: HeadObject.A_DiscFlag,
      v_A_Rounding: parseFloat(HeadObject.A_Rounding),
      v_A_LC: parseFloat(HeadObject.A_LC),
      v_A_Charges1: parseFloat(HeadObject.A_Charges1),
      v_A_DocStat: iStatus,
      v_A_RefNo4: parseFloat(HeadObject.VendorInvAmount),
      v_IP: vRdxUserInfoObj.IP,
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_TaxGross: HeadObject.TaxGross,
      v_A_Taxable: HeadObject.Tax,
      v_A_CUSTFIELD3: HeadObject.TaxType,
      v_A_CUSTFIELD4: HeadObject.RCM,
      v_A_CUSTFIELD5: HeadObject.offer,
      v_A_CUSTFIELD8: HeadObject.Batch,
      v_A_ScaleItm: HeadObject.Weighing,
      v_A_PR_DocTypI: HeadObject.PurchaseReturnType,
      v_A_MLT_TSR: "N",
      v_A_TCS: 0.0,
      v_Output: "",
      v_A_RefDocBarcode: HeadObject.POBarcode,
      v_A_RefDocType: HeadObject.A_RefDocTyp,
      v_A_RefDocNo: HeadObject.A_RefDocNo,
      // Detail fields
      v_B_Srno: parseFloat(sBufferObj.B_Srno),
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: parseFloat(sBufferObj.B_Qty),
      v_B_Unit: sBufferObj.B_Unit,
      v_B_BaseQty: parseFloat(sBufferObj.B_BaseQty),
      v_B_URateFc: parseFloat(sBufferObj.B_URateFc),
      v_B_URateLc: parseFloat(sBufferObj.B_URateLc),
      v_B_GrossAmt: parseFloat(sBufferObj.B_GrossAmt),
      v_B_LDiscPerc: parseFloat(sBufferObj.B_LDiscPerc),
      v_B_LDiscAmt: parseFloat(sBufferObj.B_LDiscAmt),
      v_B_FocFlag: sBufferObj.B_FocFlag,
      v_B_AprmtFlag: sBufferObj.B_AprmtFlag,
      v_B_NetAmt: parseFloat(sBufferObj.B_NetAmt),
      v_B_LandVal: parseFloat(sBufferObj.B_NetAmt),
      v_B_RefDocTyp: sBufferObj.B_RefDocTyp,
      v_B_RefDocNo: sBufferObj.B_RefDocNo,
      v_B_ExciseTaxAmt: parseFloat(sBufferObj.B_ExciseTaxAmt), ///0
      v_B_ExciseTaxNetAmt: parseFloat(sBufferObj.B_ExciseTaxNetAmt), //0
      v_B_TaxPerc: parseFloat(sBufferObj.B_TaxPerc), //0
      v_B_TaxAmt: parseFloat(sBufferObj.B_TaxAmt), //0
      v_SplDiscAmt1: parseFloat(sBufferObj.SplDisc),
      v_SplDiscAmt2: parseFloat(sBufferObj.SplDiscPerc),
      v_SplDiscAmt3: parseFloat(sBufferObj.SplDiscAmt),
      v_SplDiscAmt4: 0.0,
      v_SplDiscAmt5: 0.0,
      v_Field1: 0.0,
      v_Field2: sBufferObj.B_TaxPerc,
      v_Field3: 0.0,
      v_Field4: 0.0,
      v_Field5: 0.0,
      v_Field6: sBufferObj.RebateType,
      v_Field7: sBufferObj.B_FocFlag,
      v_Field8: "",
      v_Field9: HeadObject.Tax,
      v_Field10: HeadObject.TaxGross,
      v_B_TaxPerc2: parseFloat(sBufferObj.B_TaxPerc2), //0
      v_B_TaxAmt2: parseFloat(sBufferObj.B_TaxAmt2), //0
      v_B_HighCost: sBufferObj.HC, //N
      v_B_PR: sBufferObj.PR, //N
      v_B_Ad_CessAmt: parseFloat(sBufferObj.B_Ad_PCRate), //0
      v_B_Ad_PCQty: 0, //0
      v_B_Ad_PCRate: 0, //0
      v_B_Ad_NetCessAmt: parseFloat(sBufferObj.B_NetAddCess), //0
      v_B_ExpDt: sBufferObj.ExpDate,
      v_B_Narr: sBufferObj.B_Narr,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_TDiscPerc: parseFloat(sBufferObj.B_TDiscPerc),
      v_B_TDiscAmt: parseFloat(sBufferObj.B_TDiscAmt),
      v_B_Addi_Margin: 0,
      v_B_Addi_NetMargin: 0,
      v_B_NDX_DATE: new Date(),
    };

    let vSaveSIHead = await GRNNormal_saveInv03_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (vSaveSIHead?.status === 200) {
      let iVocNo = xSave
        ? vSaveSIHead?.data?.ResultSet?.DocNo
        : vRdxWmsHead.A_VocNo;

      if (vRdxWmsHead.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: vRdxWmsHead.A_VocTyp,
            A_VocNo: iVocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Set_GRNNormal_HeadObject_A_VocNo({
          A_VocNo: iVocNo,
          A_DocStat: iStatus,
        })
      );
      //approve bool type false
      if (!xSave) {
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          iVocNo,
          dispatch,
          fNewDetail,
          fBuyreGetRow
        );
        fAlertToast("SUCCESS", "Successfully posted");
      } else {
        let { A_CrAc, A_CrAcName, A_DrAc, A_DrAcName } =
          vSaveSIHead?.data?.ResultSet;

        dispatch(
          Set_GRNNormal_HeadObject_DrCrAccount({
            A_CrAc: A_CrAc,
            A_CrAcName: A_CrAcName,
            A_DrAc: A_DrAc,
            A_DrAcName: A_DrAcName,
          })
        );
        fBuyreGetRow(HeadObject.A_VocTyp, iVocNo, HeadObject.A_Loc);
        console.log(vSaveSIHead?.data?.ResultSet);
        let obj = {
          ...vSaveSIHead?.data?.ResultSet?.Detail[0], // Merging the existing object
          ItemCd: sBufferObj.B_Itmcd, // Adding new field itmcd,
          // ItemCd:101421,// Adding new field itmcd,
          // SrNo:1// Adding new field itmcd,
        };
        setSerialDetalModal(obj);
        let { Batch, Serial, AutoGrn, SrNo } =
          vSaveSIHead?.data?.ResultSet.Detail[0];
        if (Batch == "Y" || Serial == "Y") {
          fOpenBatchModal(SrNo, sBufferObj.B_BaseQty, sBufferObj.B_PackQty);
          setBatchObj((obj) => ({
            ...obj,
            SrNo: SrNo,
            ItemCode: sBufferObj.B_Itmcd,
            ItemName: sBufferObj.B_ItmName,
            Qty: sBufferObj.B_Qty,
            Unit: sBufferObj.B_UnitName,
            BaseQty: sBufferObj.B_BaseQty,
          }));
          let currentUnitArr = await GetUnitArr(
            sBufferObj.B_Itmcd,
            setBatchUnit
          );
          let currentPackQty = 0;

          if (currentUnitArr.length > 0) {
            setBatchDetailObj((obj) => ({
              ...obj,
              BatchDetail_Unit: currentUnitArr[0]?.Unit,
              BatchDetail_PackQty: currentUnitArr[0]?.PackQty,
            }));
            currentPackQty = currentUnitArr[0]?.PackQty;
          }

          fBatch_BaseQty_Calculation(
            sBatchDetailObj.BatchDetail_Qty,
            currentPackQty
          );

          fOpenBatchModal(
            sBufferObj.B_Srno,
            sBufferObj.B_BaseQty,
            currentPackQty
          ); //baseqty 0
        }

        if (AutoGrn == "Y") {
          // setRegisterSerialNumberModal(true);
        }

        fNewDetail(
          iVocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_TaxType
        );
        fAlertToast("SUCCESS", "Successfully Saved");
      }
    }
  };

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_UserCd: vRdxuserInfo.UserID,
      v_DocStat: vRdxWmsHead.A_DocStat,
      v_IP: vRdxuserInfo.IP,
    };
    const vRevereTransaction = await GRNNormal_InvTransReverseINV03_GETROW(
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };

  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");

        await handleSaveOrApprove(xsave, docstatus);

        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };
  const processHeadResponse = (response) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        setTimeout(async () => {
          await fDetailConfirmation();
        }, 100);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };

  const fDetailConfirmation = async () => {
    const { HeadObject } = GRNNormalRo();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Unit: sBufferObj.B_Unit,
      v_A_Loc: HeadObject.A_Loc,
      v_B_Qty: sBufferObj.B_Qty,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_Paymode: HeadObject.A_PayMode,
      v_NumerFormat: "N" + HeadObject.A_Rounding,
      v_Foc: sBufferObj.B_FocFlag,
      v_unitratelc: sBufferObj.B_URateLc,
      v_ldiscperc: sBufferObj.B_LDiscPerc,
      v_netAmt: sBufferObj.B_NetAmt,
      v_B_RefDocTyp: sBufferObj.B_RefDocTyp,
      v_B_RefDocNo: sBufferObj.B_RefDocNo,
      v_Party: HeadObject.A_Party,
      v_TaxType: HeadObject.TaxType,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_AprmtFlag: sBufferObj.B_AprmtFlag,
    };
    let resp = await Grn_ConfirmINV03LineItem_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        await handleSaveOrApprove(true);
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
      return false;
    }
  };

  const processApproveResponse = (response, xbool, docstatus) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        setTimeout(async () => {
          await fApproveConfirmation(xbool, docstatus);
        }, 100);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };
  const fApproveConfirmation = async (xbool = false, docstatus) => {
    const { HeadObject } = GRNNormalRo();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,

      v_A_PayMode: HeadObject.A_PayMode,
      v_A_Buyer: HeadObject.A_Buyer,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("YYYY/MM/DD"),
      v_A_Party: HeadObject.A_Party,
      v_A_Loc: HeadObject.A_Loc,
      //confirmation
      NumerFormat: "N" + HeadObject.A_Rounding,
      PartyName: HeadObject.A_PartyName,
      DocTypPR: HeadObject.PurchaseReturnType,
      RefNo: HeadObject.A_RefNo,
    };
    let resp = await ApproveconfirmationINV03(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        await handleSaveOrApprove(xbool, docstatus);
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
      return false;
    }
  };

  const validationINV03 = async () => {
    const { HeadObject } = GRNNormalRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    const iBr = vRdxDBLocation.find((item) => item.UId === HeadObject.A_Loc);

    const obj = {
      v_A_Buyer: HeadObject.A_Buyer,
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_Br: iBr?.Br || "",
      v_A_PostDt: moment(HeadObject.A_PostDt).format("YYYY/MM/DD"),
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_Party: HeadObject.A_Party,
      v_A_Loc: HeadObject.A_Loc,
      // detail
      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: sBufferObj.B_Qty,
      v_B_RefDocTyp: sBufferObj.B_RefDocTyp,
      v_B_RefDocNo: sBufferObj.B_RefDocNo,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_Unit: sBufferObj.B_Unit,
      v_InvoiceNo: HeadObject.A_RefNo,
      v_B_PR: sBufferObj.PR,
    };

    let resp;
    try {
      resp = await GRNNormal_validationINV03_GETROW(
        fcheck_null_undefine_replace_empty(obj)
      );
    } catch (err) {
      // Unexpected network or code error
      fAlertToast(
        "FAILED",
        err.message || "Unexpected error during validation"
      );
      return false;
    }

    if (resp?.status === 200) {
      const resultSet = resp.data?.ResultSet;
      if (Array.isArray(resultSet) && resultSet.length > 0) {
        processHeadResponse(resultSet);
      } else {
        await fDetailConfirmation();
      }
      return true;
    }

    // handle errors
    const errorResponse = resp.response;
    const errorField = errorResponse?.data?.message?.field;
    const errorMsg = errorResponse?.data?.message?.msg || "Unknown error";
    const errorCode = errorResponse?.data?.message?.code;

    if (errorCode > 500) {
      fStockSetupRequestModal(
        sBufferObj.B_Itmcd,
        sBufferObj.B_ItmName,
        errorMsg
      );
    } else {
      // handle normal validation error
      if (ErrorMsg.hasOwnProperty(errorField)) {
        setErrorMsg((prev) => ({ ...prev, [errorField]: errorMsg }));
      } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
        setErrorMsgDetail((prev) => ({ ...prev, [errorField]: errorMsg }));
      } else {
        fAlertToast("FAILED", errorMsg);
      }

      // focus the field if exists
      document?.getElementsByName(errorField)?.[0]?.focus();
    }

    return false;
  };

  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    if (vRdxWmsHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await SaveINV03(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await SaveINV03(xsave, docstatus);
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fCloseReverseTransactionModal(setReverseTransactionModal);
    fClearErrorMsg();

    timeout = setTimeout(async () => {
      setSaveLoaded(false);
      if (
        vRdxWmsHead.A_DocStat === "DRAFT" ||
        vRdxWmsHead.A_DocStat == "POST"
      ) {
        confirmAlert({
          title: "Reverse",
          message: `Are you sure to Reverse.`,
          buttons: [
            {
              className: "alertBtn",
              label: "Yes",
              onClick: async () => {
                let resp = await GetRevereTransaction();
                if (resp?.status === 200) {
                  fClearErrorMsg();
                  dispatch(
                    Set_GRNNormal_HeadObject_A_DocStat({
                      A_DocStat: "ENTER",
                    })
                  );
                  fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                }
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          setErrorMsg,
          sFooterObj,
          vMediaQuery,
          fSummary
        );

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          vRdxWmsHead,
          sBufferObj,
          setErrorMsgDetail,
          sDetailGridData
        );

        if (!validationDetil) return;

        // let server_Validation =true
        await validationINV03();
      }
    }, 800);
  };

  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = GRNNormalRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let iBr = vRdxDBLocation.find((item) => item.UId == HeadObject.A_Loc);

    let obj = {
      //approve cnfimartion:HeadObject.qqqqq,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_LC: HeadObject.A_LC,
      v_A_Charges1: HeadObject.A_Charges1,
      v_A_DiscFlag: HeadObject.A_DiscFlag,
      v_A_PayMode: HeadObject.A_PayMode,
      v_A_Buyer: HeadObject.A_Buyer,
      v_A_PostDt: HeadObject.A_PostDt,
      v_A_Party: HeadObject.A_Party,
      v_A_Loc: HeadObject.A_Loc,
      v_A_CUSTFIELD5: HeadObject.offer,
      //confirmation
      v_A_Br: iBr?.Br || "",
      v_InvoiceNo: HeadObject.A_RefNo,
      // NumerFormat: "N" + HeadObject.A_Rounding,
      // PartyName: HeadObject.A_PartyName,
      // DocTypPR: HeadObject.PurchaseReturnType,
      // RefNo: HeadObject.A_RefNo,
    };
    let resp = await GRNNormal_ApproveINV03_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processApproveResponse(resp?.data.ResultSet, xbool, docstatus);
        // processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        await fApproveConfirmation(xbool, docstatus);
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (ErrorMsg.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg || "error in validationWMINV03 "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(
        vRdxWmsHead,
        setErrorMsg,
        sFooterObj,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      if (
        Number(vRdxWmsHead.VendorInvAmount) != Number(sFooterObj.netAmtFinal)
      ) {
        fAlertToast(
          "FAILED",
          "Vendor invoice amount and GRN Amount is not matching"
        );
        document.getElementsByName("VendorInvAmount")[0]?.focus();
        return;
      }

      await ValidationApprove(false, xDocStatus);
      // if (!Searver_ValidationApprove) return;

      // if (!!Searver_ValidationApprove) {
      //   setTimeout(() => {
      //     confirmAlert({
      //       title: "Approve",
      //       message: "Are you want to Approve..",
      //       buttons: [
      //         {
      //           className: "alertBtn",
      //           name: "SaveYes",
      //           label: "Yes",
      //           onClick: async () => {
      //             await SaveINV03(false, xDocStatus);
      //           },
      //         },
      //         {
      //           className: "alertBtn",
      //           label: "No",
      //           onClick: () => {
      //             return;
      //           },
      //         },
      //       ],
      //     });
      //   }, 200);
      // }
    }, 800);
  };

  const clearLoactionState = () => {
    if (!!vMediaQuery) {
    } else {
      location.state = {
        GRNDocTyp: "",
        GrnDocNo: "",
        RefNo: "",
        RefVocNo: "",
        RefVocTyp: "",
      };
    }
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
    setRevNarr("");
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      let idefaultTaxTypeValue = "INTRN001";
      let iDefaultTaxType = await GetTransTaxType(
        vRdxDBLocation[0].UId, //locaation
        "", //partyname in new it is empty,
        dispatch
      );

      if (Object.keys(iDefaultTaxType).length != 0) {
        idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
      }

      fNewHead();
      fNewDetail(0, 0, sDocLoading[0]?.VocTyp, idefaultTaxTypeValue);
      document.getElementsByName("A_PostDt")[0]?.focus();
    } else {
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        vRdxWmsHead.A_Rounding,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fNewHead = async () => {
    dispatch(Set_GRNNormal_HeadObject_Init()); // Head Clearing
    let idefaultTaxTypeValue = "INTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxDBLocation[0].UId, //locaation
      "", //partyname in new it is empty,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
    }

    let vBuyerArr = await fBuyreGetRow(
      sDocLoading[0]?.VocTyp,
      0,
      vRdxDBLocation[0]?.UId,
      vRdxDBLocation
    );

    // Setting Initial List Box 0th Object
    dispatch(
      Wms_GRNNormal_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxDBLocation[0]?.UId,
        A_Curr: sCurrency[0]?.Uid,
        A_ExRate: sCurrency[0]?.Rate,
        A_Buyer: "",
        TaxType: idefaultTaxTypeValue,
        PurchaseReturnType: sPurchaseReturnType[0]?.VocTyp,
        Type: sType[0].UId, //sForm
      })
    );

    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      sDocLoading[0]?.Paymode,
      dispatch
    );
    setPaymodeEnable(PaymodeEnable);

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: (0).toFixed(sRoundingVal),
      A_SplDiscAmt1: (0).toFixed(sRoundingVal),
      A_TDiscAmt: (0).toFixed(sRoundingVal),
      A_LDiscAmt: (0).toFixed(sRoundingVal),
      A_FocAmt: (0).toFixed(sRoundingVal),
      A_NetExcise: (0).toFixed(sRoundingVal),
      A_Tax: (0).toFixed(sRoundingVal),
      A_Tax2: (0).toFixed(sRoundingVal),
      A_AddCess: (0).toFixed(sRoundingVal),
      A_LandVal: (0).toFixed(sRoundingVal),
      netAmtFinal: (0).toFixed(sRoundingVal),
    }));

    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  //vTaxType  vTaxType == "INTRN002" then tax %0
  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    setBufferObj(vBufferObjInit);
    const { HeadObject } = GRNNormalRo();
    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
    }));
    if (HeadObject.POBarcode != "") {
      setBufferObj((obj) => ({
        ...obj,
        B_RefDocTypName: HeadObject.A_RefDocTypName,
        B_RefDocTyp: HeadObject.A_RefDocTyp,
        B_RefDocNo: HeadObject.A_RefDocNo,
      }));
    }
    //if inter.comp then tax group should be 0
    let iTaxPerc = 0;
    let iCessPerc = 0;
    if (vTaxType == "INTRN002" || vTaxType == "INTRN003") {
      let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
        return obj.UId == vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val;
      });
      let vCessGroupValue = vRdxGRNtax2.find((obj) => {
        return obj.UId == vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val;
      });
      if (vtaxGroupValue) {
        setBufferObj((obj) => ({
          ...obj,
          B_TaxDept: vtaxGroupValue?.UId,
          B_TaxPerc: vtaxGroupValue?.Perc,
          B_TaxDept2: vCessGroupValue?.UId,
          B_TaxPerc2: vCessGroupValue?.Perc,
        }));
      }
      iTaxPerc = vtaxGroupValue?.Perc;
      iCessPerc = vCessGroupValue?.Perc;
    }
    setRSP_MRP_Obj({ RSP: 0, MRP: 0 });
    setUnit([]);
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iTaxPerc
        : vRdxGRNtax1[0].Perc, //tax1%
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iCessPerc
        : vRdxGRNtax2[0].Perc, //tax%2
      0, //sBufferObj.AddCess,
      0, //Rounding
      0 //SplDiscPer
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, setDetailGridData, setFooterObj, xVocTyp);
    setTimeout(() => {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }, 100);
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteAPi(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteAPi(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteAPi = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_SrNo: Srno,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
    };

    const resp = await GRNNormal_fINV03_Delete_GETROW(vDeleteSIHeadObj);

    if (resp?.status === 200) {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_GRNNormal_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail,
          fBuyreGetRow
        );
        // fNewDetail(
        //   vRdxWmsHead.A_VocNo,
        //   vRdxWmsHead.A_Rounding,
        //   vRdxWmsHead.A_VocTyp,

        // );
        fAlertToast("SUCCESS", "Successfully Deleted");
      } else {
        fAlertToast("SUCCESS", "Successfully Deleted Line Item");
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          0,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.TaxType
        );
      }
    }
  };

  const fDetail_Grid_DoubleClick = async (item) => {
    setBatchObj((obj) => ({
      ...obj,
      SrNo: item.row.B_Srno,
      ItemCode: item.row.B_Itmcd,
      ItemName: item.row.ItmName,
      Qty: item.row.B_Qty,
      Unit: item.row.UnitName,
      BaseQty: item.row.B_BaseQty,
    }));
    let obj = {
      // Merging the existing object
      SrNo: item.row.B_Srno,
      ItemCd: item.row.B_Itmcd,
      Batch: item.row.BatchCrl,
      Serial: item.row.SerialCrl,
      AutoGrn: item.row.AutoGrn,
    };
    console.log(obj);

    setSerialDetalModal(obj);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Qty: 0,
    }));

    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setBatchUnit);
    let currentPackQty = 0;

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === item.row.B_Unit;
      });
      if (!!vItemUnitSet) {
        setBatchDetailObj((obj) => ({
          ...obj,
          BatchDetail_Unit: vItemUnitSet.Unit,
          BatchDetail_PackQty: vItemUnitSet?.PackQty,
        }));
        currentPackQty = vItemUnitSet?.PackQty;
      } else {
        setBatchDetailObj((obj) => ({
          ...obj,
          BatchDetail_Unit: currentUnitArr[0].Unit,
          BatchDetail_PackQty: currentUnitArr[0]?.PackQty,
        }));
        currentPackQty = currentUnitArr[0]?.PackQty;
      }
    }
    fBatch_BaseQty_Calculation(sBatchDetailObj.BatchDetail_Qty, currentPackQty);
    let { Batch, Serial, AutoGrn, SrNo } = item.row;
    if (Batch == "Y" || Serial == "Y") {
      fOpenBatchModal(item.row.B_Srno, item.row.B_BaseQty, currentPackQty); //baseqty 0
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    console.log(item.row);

    setBufferObj((obj) => ({
      ...obj,
      B_VocTyp: vRdxWmsHead.B_VocTyp,
      B_VocNo: vRdxWmsHead.B_VocNo,
      B_Srno: item.row.B_Srno,
      B_RefDocTyp: item.row.B_RefDocTyp,
      B_RefDocTypName: !!item.row.RefVocName ? item.row.RefVocName : "",
      B_RefDocNo: item.row.B_RefDocNo,
      B_Itmcd: item.row.B_Itmcd,
      // B_Barcode: "",
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      SplDisc: item.row.SplDiscAmt1,
      B_BaseQty: item.row.B_BaseQty,
      B_PackQty: item.row.Packing,
      // B_PackQty: item.row.B_PackQty, //not in grid
      B_URateFc: item.row.B_URateFc,
      B_GrossAmt: item.row.B_GrossAmt,
      B_LDiscPerc: item.row.B_LDiscPerc,
      B_LDiscAmt: item.row.B_LDiscAmt,
      B_TDiscPerc: item.row.B_TDiscPerc,
      B_TDiscAmt: item.row.B_TDiscAmt,
      B_FocFlag:
        item.row.B_FocFlag == "" || item.row.B_FocFlag == null
          ? "N"
          : item.row.B_FocFlag,
      B_AprmtFlag: item.row.B_AprmtFlag, //foc flag dropdown
      B_FocAmt: item.row.B_FocAmt,
      B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,
      B_NetAmt: item.row.B_NetAmt,
      B_TaxDept: item.row.B_TaxDept,
      B_TaxPerc: item.row.B_TaxPerc,
      B_TaxAmt: item.row.B_TaxAmt,
      B_TaxDept2: item.row.B_TaxDept2,
      B_TaxPerc2: item.row.B_TaxPerc2,
      B_TaxAmt2: item.row.B_TaxAmt2,
      B_NetAddCess: item.row.B_Ad_NetCessAmt,
      ReduceCost: item.row.Field7,
      ExpDate: !!item.row.B_ExpDt ? item.row.B_ExpDt : new Date(),
      PR: item.row.B_PR == "" || item.row.B_PR == null ? "N" : item.row.B_PR,
      HC:
        item.row.B_HighCost == "" || item.row.B_HighCost == null
          ? "N"
          : item.row.B_HighCost,
      RebateType: item.row.Field6,
      SplDiscPerc: item.row.SplDiscAmt2.toFixed(4),
      SplDiscAmt: item.row.SplDiscAmt3,
      B_Rounding: item.row.B_Rounding ? item.row.B_Rounding : 0,
      B_LandVal: item.row.B_LandVal,
      B_URateLc: item.row.B_URateLc,
      B_Ad_PCRate: item.row.B_Ad_PCRate,
      // SuppRefNo: item.row.B_VocNo,
      // SuppRefNo1: item?.row?.SuppRefNo1,
      // B_Ad_CessAmt: 0,
      // B_Ad_PCQty: 0,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    let resp = await GetUnitRate(
      item.row.B_Itmcd,
      vUnitvalue?.Unit,
      vRdxWmsHead?.A_Party,
      vRdxWmsHead?.A_Loc,
      vRdxWmsHead?.A_RefDocTyp,
      vRdxWmsHead?.A_RefDocNo
    );

    if (resp?.UnitChangeDetails.length > 0) {
      setRSP_MRP_Obj({
        RSP: resp?.UnitChangeDetails[0].RSP,
        MRP: resp?.UnitChangeDetails[0].MRP,
      });
    } else {
      setRSP_MRP_Obj({ RSP: 0, MRP: 0 });
    }

    fCloseViewModal();
  };

  const fBuyreGetRow = async (
    A_VocTyp = vRdxWmsHead.A_VocTyp,
    A_VocNo = vRdxWmsHead.A_VocTyp,
    A_Loc = vRdxWmsHead.A_Loc,
    vRdxDBLocationArr = vRdxDBLocation
  ) => {
    let iBr = vRdxDBLocationArr?.find((item) => item?.UId == A_Loc);
    let iObj = {
      v_VocTyp: A_VocTyp,
      v_VocNo: A_VocNo,
      v_TrnTyp: sTrnTyp,
      v_Br: iBr?.Br,
      // Loc: vRdxWmsHead.A_Loc,
    };
    let vRespi = await GRNNormal_BUYER_GETROW_GETROW(iObj);
    if (vRespi?.status === 200) {
      setBuyer(vRespi?.data?.ResultSet);
      return vRespi?.data?.ResultSet;
    } else {
      return [];
    }
  };

  const ExactSearchRefNo = async (xRefDocNo) => {
    let srcDocNoArr = await GetRefDocInbound(
      xRefDocNo,
      "",
      "",
      setRefDocModalArr
    );
    let vExactSearchValue = srcDocNoArr.find((obj) => {
      return xRefDocNo === obj.VocNo;
    });
    if (!!vExactSearchValue) {
      dispatch(
        Wms_GRNNormal_HeadObject_RefNo_ExactSearch_Set({
          A_RefDocTyp: vExactSearchValue.VocTyp,
          A_RefDocTypName: vExactSearchValue.VocName,
          A_RefDocNo: vExactSearchValue.VocNo,
          A_Party: vExactSearchValue.Vendor,
          A_PartyName: vExactSearchValue.PartyName,
          Type: vExactSearchValue.Source,
          UnloadingBay: vExactSearchValue.LDPay,
          UnloadingBayName: vExactSearchValue.LDPayName,
          A_PostDt: vExactSearchValue.GRNDate,
          A_RefNo: vExactSearchValue.RefNo,
          A_RefDt: vExactSearchValue.RefDate,
          VendorInvAmount: vExactSearchValue.InvAmt,
          A_RefDocVer: vExactSearchValue.SrNo,
        })
      );
      clearLoactionState();
      return vExactSearchValue;
    } else {
      return false;
    }
    //afer loading,if we press arrow left then refresh location state should remove
  };
  //esc keyZ close item dropdown
  const escFunction = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setItemToggleDropdown(false);
        setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      }
    },
    [setItemToggleDropdown]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    if (vRdxDBKernObj?.DIGIT_ROUNDING?.Val) {
      setRoundingVal(Number(vRdxDBKernObj?.DIGIT_ROUNDING?.Val));
    }

    if (
      !!vRdxDBKernObj?.BATCH_NO_AUTO?.Val &&
      vRdxDBKernObj?.BATCH_NO_AUTO?.Val === "Y"
    ) {
      setbatchFlag(true);
    }

    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setDocLoading,
      setCurrency,
      setType,
      setLoc,
      setPurchaseReturnType
    );

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
    };
    let vDocLoadingArr = iAttributeResp?.DocLoading;

    if (vDocLoadingArr.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }
    let iPurchaseReturnType = {
      VocTyp: "",
      VocName: "",
    };
    let vPurchaseReturnTypeArr = iAttributeResp?.PurchaseReturnType;

    if (vPurchaseReturnTypeArr.length > 0) {
      iPurchaseReturnType = vPurchaseReturnTypeArr[0];
    }

    let iType = {
      UId: "",
      Name1: "",
    };
    let vTypeArr = iAttributeResp?.Type;

    if (vTypeArr.length > 0) {
      iType = vTypeArr[0];
    }
    var iCurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };
    let vCurrencyArr = iAttributeResp?.Currency;
    if (vCurrencyArr.length > 0) {
      setCurrency(vCurrencyArr);
      iCurrencyArr.Uid = vCurrencyArr[0]?.Uid;
      iCurrencyArr.Name1 = vCurrencyArr[0]?.Name1;
      iCurrencyArr.Rate = vCurrencyArr[0]?.Rate;
    }

    let iLoc = {
      UId: "",
      Name1: "",
      BatchCtrl: "",
      Br: "",
      BrName: "",
      MBCDSearch: "",
    };
    let vLocArr = iAttributeResp?.Loc;

    if (vLocArr.length > 0) {
      const newObj = {
        UId: "",
        Name1: " ",
        BatchCtrl: "",
        Br: "",
        BrName: "",
        MBCDSearch: "",
      };

      // Use the spread operator to create a new array with the new object added at the beginning
      iLoc = vLocArr[0];
      setSearchLoactionArr([newObj, ...iAttributeResp?.Loc]);
    }

    let iTaxType = {
      UId: "",
      Name1: "",
    };
    let vTaxTypeArr = iAttributeResp?.TaxType;

    if (vTaxTypeArr.length > 0) {
      iTaxType = vTaxTypeArr[0];
    }

    let iAuduitFields = {
      id: "",
      name: "",
    };
    let vAuduitFieldsArr = iAttributeResp?.AuduitFields;

    if (vAuduitFieldsArr.length > 0) {
      iAuduitFields = vAuduitFieldsArr[0];
    }

    let vDefaultTaxType = "INTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? iLoc?.UId
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_Party,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }

    // Object.keys(obj).length === 0
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      vDocLoadingArr[0]?.Paymode,
      dispatch
    );

    setPaymodeEnable(PaymodeEnable);
    let iBuyer = {
      UId: "",
      Name1: "",
      Name2: "",
    };

    let vBuyerArr = await fBuyreGetRow(
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      vRdxWmsHead?.A_VocNo,
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? iLoc?.UId
        : vRdxWmsHead?.A_Loc,
      iAttributeResp?.Loc
    );
    if (vBuyerArr.length > 0) {
      iBuyer = vBuyerArr[0];
    }
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,

        A_Curr:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Uid
            : vRdxWmsHead?.A_Curr,
        A_Currname:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Name1
            : vRdxWmsHead.A_Currname,
        A_ExRate:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Rate
            : vRdxWmsHead.A_ExRate,
        A_PayMode:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? currentPayMode
            : vRdxWmsHead.A_PayMode, //on load sPaymode[0]?.Uid but refreshing default value, && paymode has default value so we are checking with curr
        TaxType:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? vDefaultTaxType
            : vRdxWmsHead.TaxType,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
            ? iLoc?.UId
            : vRdxWmsHead?.A_Loc,
        PurchaseReturnType:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iPurchaseReturnType?.VocTyp
            : vRdxWmsHead.PurchaseReturnType,
        Type:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iType?.UId
            : vRdxWmsHead.Type,
        // A_Buyer:
        //   vRdxWmsHead.A_Curr == "" ||
        //   vRdxWmsHead.A_Curr === null ||
        //   vRdxWmsHead.A_Curr === undefined
        //     ? iBuyer?.UId
        //     : vRdxWmsHead.A_Buyer,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      vRdxWmsHead.A_Rounding,
      setDetailGridData,
      setFooterObj,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp
    );

    //on load inbound type= vendor but while refresh rdx value will not change

    GetDefcustomersetting(
      vRdxWmsHead.Party,
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? iLoc.UId
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.Type,
      dispatch
    );
    let iInterCompanyDependency = {
      B_TaxPerc: vRdxGRNtax1[0].Perc,
      B_TaxPerc2: vRdxGRNtax2[0].Perc,
    };
    //if inter.comp then tax group should be 0
    if (iDefaultTaxType == "INTRN002" || iDefaultTaxType == "INTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
      );
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      vRdxWmsHead.A_Curr == "" ||
        vRdxWmsHead.A_Curr === null ||
        vRdxWmsHead.A_Curr === undefined
        ? iCurrencyArr?.Rate
        : vRdxWmsHead.A_ExRate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      vRdxWmsHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc, // initial state A_DiscPerc 0 if refresh then current value
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      iInterCompanyDependency.B_TaxPerc, //tax1%
      iInterCompanyDependency.B_TaxPerc2, //tax%2
      0, //sBufferObj.AddCess,
      0, //Rounding
      0 //SplDiscPer
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_TDiscPerc: vRdxWmsHead?.A_DiscPerc,
      SplDiscAmt,
    }));

    if (GRNDocTyp !== "" && GrnDocNo !== "") {
      setTimeout(() => {
        fDisplay(GRNDocTyp, GrnDocNo, dispatch, fNewDetail, fBuyreGetRow);

        clearLoactionState();
      }, 100);
    } else if (RefVocNo !== "") {
      let vExactSearchValue = await ExactSearchRefNo(RefVocNo);
      if (!!vExactSearchValue) {
        fReset_Linewise_Rebate(setBufferObj);

        GetDefcustomersetting(
          vExactSearchValue.Vendor,
          iLoc.UId,
          vExactSearchValue.Source,
          dispatch
        );
        fDiscFlagDependency(vExactSearchValue.Source.A_CUSTFIELD6, dispatch);
        let vDefaultTaxType = "INTRN001";
        //
        let iDefaultTaxType = await GetTransTaxType(
          vRdxWmsHead.A_Loc == "" ||
            vRdxWmsHead.A_Loc === null ||
            vRdxWmsHead.A_Loc === undefined
            ? iLoc.UId
            : vRdxWmsHead.A_Loc,
          vExactSearchValue.Vendor,
          dispatch
        );
        if (Object.keys(iDefaultTaxType).length != 0) {
          vDefaultTaxType = iDefaultTaxType?.TaxType;
        }

        //if inter.comp then tax group should be 0
        if (vDefaultTaxType == "INTRN002" || vDefaultTaxType == "INTRN003") {
          InterCompanyDependency(
            vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
            vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
          );
        }

        dispatch(
          Set_GRNNormal_HeadObject_TaxType({
            TaxType: vDefaultTaxType,
          })
        );
        clearLoactionState();
      }
    }
  }, []);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
    console.log("resultObj", resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      const toggleElement = event.target.closest(".toggleSearch");
      if (!toggleElement) {
        setItemToggleDropdown(false);
        setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);
  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("GRNNormalContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "P";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    {
      field: "updateIcon",
      headerName: "Detail",
      width: 50,
      sortable: false,
      filterable: false,
      align: "center",
      // hide: vRdxDBKernObj.STKSETUP_CHANGEREQ?.Val == "Y" ? true : false,
      renderCell: (params) => (
        <IconButton
          disabled={
            vRdxuserInfo?.UserGroupCode == "01" ||
            vRdxuserInfo?.UserRights?.USRCUSTFIELD100?.toUpperCase() === "Y"
              ? true
              : vRdxDBKernObj.STKSETUP_CHANGEREQ?.Val === "Y"
          }
          onClick={(e) => xGCStockSetupChangeReq(e, params.row)}
          color="primary"
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
    { field: "B_Srno", headerName: "Sr.No", width: 50 },
    { field: "B_Itmcd", headerName: "Item Code", width: 100 },
    // { field: "B_Barcode", headerName: "Barcode", width: 100 },
    { field: "ItmName", headerName: "Item Name", width: 300 },
    { field: "B_Qty", headerName: "Qty", width: 100 },
    { field: "B_Unit", headerName: "B_Unit", width: 100, hide: true },
    { field: "UnitName", headerName: "Unit", width: 100 },
    { field: "B_URateFc", headerName: "Unit Rate", width: 100 },
    { field: "B_GrossAmt", headerName: "Gross.Amt", width: 90 },
    { field: "B_LDiscPerc", headerName: "L Disc %", width: 100 },
    { field: "B_LDiscAmt", headerName: "L Disc.Amt", width: 100 },
    { field: "B_FocAmt", headerName: "Foc.Amt", width: 100 },
    { field: "B_NetAmt", headerName: "Net value", width: 100 },
    { field: "B_ExciseTaxNetAmt", headerName: "B_ExciseTaxNetAmt", width: 100 },
    { field: "B_TaxAmt", headerName: "B_TaxAmt", width: 100 },
    { field: "B_ExciseTaxAmt", headerName: "ExciseTaxAmt", width: 100 },
    { field: "B_ExciseTaxPerc", headerName: "ExciseTaxPerc", width: 100 },
    { field: "SplDiscAmt1", headerName: "SplDisc", width: 150 },
    { field: "B_TaxDept", headerName: "B_TaxDept", width: 100 },
    { field: "B_TDiscAmt", headerName: "TDiscAmt" },
    { field: "B_TDiscPerc", headerName: "TDiscPerc" },
    { field: "Field6", headerName: "RebateType" },
    { field: "Field7", headerName: "ReduceCost" },
    { field: "v_SplDiscAmt2", headerName: "Disc %" },
    { field: "v_SplDiscAmt3", headerName: "Disc Amt" },
  ]);
  //GCSearch
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const [GridDataColumnsRefDocSearch, setGridDataColumnsRefDocSearch] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "VocNo", headerName: "Doc.No", width: 110 },
      { field: "PartyName", headerName: "Party Name", width: 350 },
      { field: "Source", headerName: "Source", width: 110 },
      { field: "PDTUserName", headerName: "PDT User", width: 110 },
      { field: "LDPayName", headerName: "Bay", width: 110 },
      { field: "ExpcTimeStart", headerName: "Starting Time", width: 180 },
      {
        field: "GRNDate",
        type: "date",
        headerName: "GRNDate",
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        width: 180,
      },
      { field: "GrnDocTyp", headerName: "GrnDocTyp", width: 90 },
      { field: "GrnDocNo", headerName: "GrnDocNo", width: 110 },
      { field: "RefNo", headerName: "Ref.No", width: 70 },
      {
        field: "RefDate",
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        headerName: "Ref.Date",
        width: 180,
      },
    ]);
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ]);
  const [GridDataColumnsSalesGroupModal, setGridDataColumnsSalesGroupModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "UId", headerName: "Code" },
      { field: "Srno", headerName: "SrNo", width: 90 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "EMPNAME", headerName: "Employee Name", width: 350 },
      { field: "Typ", headerName: "Type", width: 100 },
      { field: "Active", headerName: "Active", width: 100 },
    ]);
  const [GridDataColumnsEmployeeModal, setGridDataColumnsEmployeeModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "SrNo", headerName: "SrNo", width: 50 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "SName", headerName: "Name", width: 300 },
      { field: "FName", headerName: "First Name", width: 150, hide: true },
      { field: "LName", headerName: "Last Name", width: 180, hide: true },
      { field: "MName", headerName: "Middle Name", width: 100, hide: true },
      { field: "InActive", headerName: "InActive", width: 60 },
      { field: "JOBTITLE", headerName: "Job Title", width: 80 },
      { field: "Gender", headerName: "Gender", width: 60 },
      {
        field: "DOB",
        headerName: "DOB",
        width: 100,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Country", headerName: "Country", width: 120 },
      { field: "Maritial", headerName: "Maritial", width: 60 },
      { field: "Mobile", headerName: "Mobile", width: 120 },
      { field: "Dept", headerName: "Dept", width: 50 },
      { field: "Br", headerName: "Br", width: 50 },
      { field: "Loc", headerName: "Loc", width: 50 },
      {
        field: "EmployementDt",
        headerName: "EmployementDt",
        width: 180,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      {
        field: "DOJ",
        headerName: "DOJ",
        width: 190,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Phone", headerName: "Phone", width: 90 },
      { field: "EMail", headerName: "EMail", width: 150 },
      { field: "CompEMail", headerName: "CompEMail", width: 90 },
      { field: "CompPhone", headerName: "CompPhone", width: 90 },
      { field: "CompExt", headerName: "CompExt", width: 90 },
      { field: "CompMobile", headerName: "CompMobile", width: 120 },
      {
        field: "TerminationDt",
        headerName: "TerminationDt",
        width: 90,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
    ]);
  const [GridDataColumnsBatch, setGridDataColumnsBatch] = useState([
    { field: "id", headerName: "id", hide: true },
    { field: "C_VocTyp", headerName: "VocTyp", hide: true },
    { field: "C_VocNo", headerName: "VocNo", hide: true },
    { field: "C_RowId", headerName: "SrNo" },
    { field: "C_SrNo", headerName: "SrNoHead", hide: true },
    { field: "C_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "ItemName", headerName: "Item Name", width: 250, hide: true },
    { field: "C_BatchNo", headerName: "Batch No" },
    { field: "C_BatchDt", headerName: "MF Date" },
    { field: "C_ExpDt", headerName: "Exp Date" },
    { field: "C_Qty", headerName: "Qty" },
    { field: "C_BaseQty", headerName: "BaseQty" },
    { field: "UnitName", headerName: "Unit" },
    { field: "C_Unit", headerName: "Unit", hide: true },
    { field: "C_Narr", headerName: "C_Narr", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp2", headerName: "C_PTyp2", hide: true },
    { field: "C_PTyp3", headerName: "C_PTyp3", hide: true },
    { field: "C_PTyp4", headerName: "C_PTyp4", hide: true },
    { field: "C_PTyp5", headerName: "C_PTyp5", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp6", headerName: "C_PTyp6", hide: true },
  ]);
  const [GridDataColumnSrno, setGridDataColumnSrno] = useState([
    { field: "id", headerName: "id", hide: true },
    { field: "C_VocTyp", headerName: "VocTyp", hide: true },
    { field: "C_VocNo", headerName: "VocNo", hide: true },
    { field: "C_RowId", headerName: "SrNo" },
    { field: "C_SrNo", headerName: "SrNoHead", hide: true },
    { field: "C_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "ItemName", headerName: "Item Name", width: 250, hide: true },
    { field: "C_BatchNo", headerName: "Serial No" },
    { field: "C_BatchDt", headerName: "MF Date" },
    { field: "C_ExpDt", headerName: "Exp Date" },
    { field: "C_Qty", headerName: "Qty" },
    { field: "C_BaseQty", headerName: "BaseQty" },
    { field: "UnitName", headerName: "Unit" },
    { field: "C_Unit", headerName: "Unit", hide: true },
    { field: "C_Narr", headerName: "C_Narr", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp2", headerName: "C_PTyp2", hide: true },
    { field: "C_PTyp3", headerName: "C_PTyp3", hide: true },
    { field: "C_PTyp4", headerName: "C_PTyp4", hide: true },
    { field: "C_PTyp5", headerName: "C_PTyp5", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp6", headerName: "C_PTyp6", hide: true },
  ]);

  //GCcustomer
  const [
    xGC_Toggle_Head_Customer_GridColumns,
    setxGC_Toggle_Head_Customer_GridColumns,
  ] = useState([
    {
      field: "id",
      headerName: "ID",
      hide: true,
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "AcCd",
      headerName: "Code",
      hide: false,
      width: 60,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Name2",
      headerName: "Name2",
      hide: false,
      width: 450,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "Name1",
      headerName: "Name1",
      hide: true,
      width: 450,
      align: "center",
      headerAlign: "center",
      Typ: "S",
      NumberFormat: "0",
    },
  ]);

  const [
    xGCSearchBtn_Columns_DropdownSearch,
    setxGCSearchBtn_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name2", headerName: "Name2", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Freight_Columns_DropdownSearch,
    setxLoaded_Cost_Freight_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Customs_Columns_DropdownSearch,
    setxLoaded_Cost_Customs_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Discount_Columns_DropdownSearch,
    setxLoaded_Cost_Discount_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_SplDiscount_Columns_DropdownSearch,
    setxLoaded_Cost_SplDiscount_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);

  const [ImageUploaderModal, setImageUploaderModal] = useState(false);
  // modal end

  const [poType, setPoType] = useState(false);
  const [poNo, setPoNo] = useState(false);

  useEffect(() => {
    // GetGitterColumns(
    //   setGridDataColumnsWmsSiDetail,
    //   "INBOUND_GRN_DETAIL",
    //   GridDataColumnsWmsSiDetail
    // );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "INBOUND_GRN_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataColumnsRefDocSearch,
      "INBOUND_GRN_REF_DOC",
      GridDataColumnsRefDocSearch
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "INBOUND_GRN_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataColumnsSalesGroupModal,
      "INBOUND_GRN_SALES_GRP",
      GridDataColumnsSalesGroupModal
    );
    GetGitterColumns(
      setGridDataColumnsEmployeeModal,
      "INBOUND_GRN_SALES_GRP_EMP",
      GridDataColumnsEmployeeModal
    );
    // GetGitterColumns(
    //   setGridDataColumnsBatch,
    //   "INBOUND_GRN_BATCH",
    //   GridDataColumnsBatch
    // );
    // GetGitterColumns(
    //   setxGC_Toggle_Head_Customer_GridColumns,
    //   "INBOUND_GRN_CUST",
    //   xGC_Toggle_Head_Customer_GridColumns
    // );
    GetGitterColumns(
      setxGCSearchBtn_Columns_DropdownSearch,
      "INBOUND_GRN_GCSearchBtn",
      xGCSearchBtn_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Freight_Columns_DropdownSearch,
      "INBOUND_GRN_Freight",
      xLoaded_Cost_Freight_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Customs_Columns_DropdownSearch,
      "INBOUND_GRN_Customs",
      xLoaded_Cost_Customs_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Discount_Columns_DropdownSearch,
      "INBOUND_GRN_Discount",
      xLoaded_Cost_Discount_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_SplDiscount_Columns_DropdownSearch,
      "INBOUND_GRN_SplDiscount",
      xLoaded_Cost_SplDiscount_Columns_DropdownSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataMSPUpdateColumns,
      "GRNITEMSMSP001",
      sGridDataMSPUpdateColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={vMediaQuery ? "container-fluid" : ""}>
      <GCNAV
        fNew={fNew}
        xDisableNew={false}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={
          DisableApproveFlag()
            ? true
            : vRdxWmsHead.A_DocStat != "ENTER"
            ? true
            : false
        }
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          DisableApproveFlag()
            ? true
            : vRdxWmsHead.A_DocStat == "ENTER" ||
              vRdxWmsHead.A_DocStat == "DRAFT"
            ? sObjRights.RApprove == "N"
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
        GCMenuBtn={
          <GCMenuBtn
            //  xvariant="outlined"
            menuLabel={<PendingIcon fontSize={"small"} />}
            menuItems={[
              // { label: "Account Detail", onClick: fAccountDetail },
              // { label: "Item MSP", onClick: fMSPUpdate },
              { label: "Pending Po", onClick: fPendingPo },
              { label: "Pallet", onClick: fPallet },
              // { label: "Link Document", onClick: fLinkDocument },
              { label: "Account Detail", onClick: fAccountDetail },

              PdfUpload() && {
                label: "Pdf Upload",
                onClick: () => {
                  setImageUploaderModal(true);
                },
              },
            ]}
          />
        }
      />
      <div style={{ paddingTop: vMediaQuery ? "38px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-inbound-grn">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <SalesInvoiceCmpButton001
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxWmsHead.A_DocStat != "ENTER"
                          ? true
                          : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <SalesInvoiceCmpButton001
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxWmsHead.A_DocStat == "ENTER" ||
                            vRdxWmsHead.A_DocStat == "DRAFT"
                          ? sObjRights.RApprove == "N"
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Search"
                    xOnClick={() => {
                      fSearch();
                    }}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    className="sales-invoice-dropdown-btn"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="PrintId"
                      onClick={(e) => {
                        fPrint("P");
                      }}
                    >
                      Venodr copy
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("G");
                      }}
                    >
                      Cooperate copy
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("D");
                      }}
                    >
                      Document
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("FC");
                      }}
                    >
                      Vendor copy alias
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("PC");
                      }}
                    >
                      {" "}
                      Price Change Request
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("A");
                      }}
                    >
                      Vondorcopy Alise
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("S");
                      }}
                    >
                      Special Discount
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("TSR");
                      }}
                    >
                      Stock Transfer - Qty
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>

                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      { label: "Pending Po", onClick: fPendingPo },
                      { label: "Pallet", onClick: fPallet },
                      PdfUpload() && {
                        label: "Pdf Upload",
                        onClick: () => {
                          setImageUploaderModal(true);
                        },
                      },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <Box id="wms-salese-invoice-id" sx={{margin:'auto', width:{xs:'100%',sm:'96%', md:'97%', lg:'97.5%'} }}>
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      fPOBarcode={(e) => {
                        dispatch(
                          Set_GRNNormal_HeadObject_Set({
                            ...vRdxWmsHead,
                            POBarcode: e.target.value,
                          })
                        );
                      }}
                      fModalPOBarcode={async (e) => {
                        if (e.key === "Enter" || e._reactName === "onClick") {
                          const payload = {
                            TransID: vRdxWmsHead.POBarcode,
                          };
                          let resp =
                            await GRNNormal_fINV02_Head_Detail_Barcode_GETROW(
                              fcheck_null_undefine_replace_empty(payload)
                            );
                          console.log("resp", resp);

                          if (
                            resp?.status === 200 &&
                            resp?.data?.ResultSet?.length == 1
                          ) {
                            let {
                              A_VocTyp = " ",
                              A_VocTypName = "",
                              A_VocNo = "",
                              A_Loc = "",
                              A_LocName = "",
                              A_Curr = " ",
                              A_Buyer = " ",
                              A_PayMode = " ",
                              A_Type = " ",
                              A_Party = " ",
                              PartyName = " ",
                            } = resp?.data?.ResultSet[0];
                            var vCurrency = sCurrency?.find((option, index) => {
                              return option.Uid === A_Curr;
                            });
                            dispatch(
                              Set_GRNNormal_HeadObject_Set({
                                ...vRdxWmsHead,
                                A_RefDocTyp: A_VocTyp,
                                A_RefDocTypName: A_VocTypName,
                                A_RefDocNo: A_VocNo,
                                A_Loc: A_Loc,
                                A_LocName: A_LocName,
                                A_Curr: A_Curr,
                                A_ExRate: vCurrency?.Rate,
                                A_Buyer: A_Buyer,
                                A_PayMode: A_PayMode,
                                A_Type: A_Type,
                                A_Party: A_Party,
                                A_PartyName: PartyName,
                              })
                            );
                            setBufferObj((obj) => ({
                              ...obj,
                              B_RefDocTypName: A_VocTypName,
                              B_RefDocTyp: A_VocTyp,
                              B_RefDocNo: A_VocNo,
                            }));
                          }
                        }
                      }}
                      vMediaQuery={vMediaQuery}
                      onchangeCheckBox={(event) => {
                        if (event.target.checked) {
                          dispatch(
                            Set_GRNNormal_HeadObject_Set({
                              ...vRdxWmsHead,
                              [event.target.name]: "Y",
                            })
                          );
                        } else {
                          dispatch(
                            Set_GRNNormal_HeadObject_Set({
                              ...vRdxWmsHead,
                              [event.target.name]: "N",
                            })
                          );
                        }
                      }}
                      sRSP_MRP_Obj={sRSP_MRP_Obj}
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      xPaymodeEnable={sPaymodeEnable}
                      xErrorMsg={sErrorMsg}
                      vRdxuserLoc={vRdxDBLocation}
                      xKey={fKey}
                      vRdxWmsHead={vRdxWmsHead}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      sType={sType}
                      sPaymode={sPaymode}
                      sCurrency={sCurrency}
                      sTax={sTax}
                      fGrnDate={fGrnDate}
                      fInvNo={fInvNo}
                      fInvDate={fInvDate}
                      fType={fForm}
                      fPaymode={fPaymode}
                      fInvAmt={fInvAmt}
                      fSelectedCurrency={fCurrency}
                      fTax={fTax}
                      sPurchaseReturnType={sPurchaseReturnType}
                      fPurchaseReturnType={fPurchaseReturnType}
                      fOffer={fOffer}
                      fLocation={fLocation}
                      xFocusInput={fFocusInput}
                      //customer

                      xGC_Toggle_Head_Customer_DropDown_Arr={
                        xGC_Toggle_Head_Customer_DropDown_Arr
                      } //sub input arr
                      xfGC_Toggle_Head_Customer_Name={
                        xfGC_Toggle_Head_Customer_Name
                      } //onchange main input
                      xGC_Toggle_Head_Customer_Toggle={
                        sGC_Toggle_Head_Customer_ToggleDropDowm
                      } //boolean true  false
                      xGC_Toggle_Head_Customer_onKeyUp={
                        fGC_Toggle_Head_Customer_onKeyUp
                      } //main input enter
                      xGC_Toggle_Head_Customer_SearchDropdownObj={
                        sGC_Toggle_Head_Customer_SearchDropdownObj
                      } //sub input obj
                      xGC_Toggle_Head_Customer_Dropdown_onChange={
                        fGC_Toggle_Head_Customer_Dropdown_onChange
                      } //sub input onchange
                      xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load={
                        fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                      } //sub input load
                      xGC_Toggle_Head_Customer_GridColumns={
                        xGC_Toggle_Head_Customer_GridColumns
                      } //sub input col
                      xGC_Toggle_Head_Customer_GridData={
                        sGC_Toggle_Head_Customer_GridData
                      } //sub input grid
                      xfGC_Toggle_Head_Customer_OnCellKeyDown={
                        fGC_Toggle_Head_Customer_OnCellKeyDown
                      } //sub input row enter
                      xfGC_Toggle_Head_Customer_OnRowClick={
                        fGC_Toggle_Head_Customer_OnRowClick
                      } //sub input row click
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sRSP_MRP_Obj={sRSP_MRP_Obj}
                        fQtyEnter={fQtyEnter}
                        setBufferObj={setBufferObj}
                        fModalPoType={async (e) => {
                          if (
                            (sBufferObj.B_RefDocTyp == "" &&
                              e.key === "Enter") ||
                            e._reactName === "onClick"
                          ) {
                            const payload = {
                              v_AnyData: sBufferObj.B_RefDocTypName,
                              v_Cd: "",
                              v_Name: "",
                              v_Prnt: "IN-PO",
                            };
                            let resp = await GRNNormal_RefDocumentType_GETROW(
                              fcheck_null_undefine_replace_empty(payload)
                            );
                            if (
                              resp?.status === 200 &&
                              resp?.data?.ResultSet?.length == 1
                            ) {
                              setBufferObj((obj) => ({
                                ...obj,
                                B_RefDocTypName: resp?.data?.ResultSet[0].Name1,
                                B_RefDocTyp: resp?.data?.ResultSet[0].UID,
                              }));
                            } else {
                              setPoType(true);
                            }
                          }
                          if (e.key === "Backspace") {
                            setBufferObj((obj) => ({
                              ...obj,
                              B_RefDocTyp: "",
                              B_RefDocNo: "",
                            }));
                          }
                        }}
                        fModalPoNo={async (e) => {
                          if (e.key === "Enter" || e._reactName === "onClick") {
                            const payload = {
                              v_AnyData: sBufferObj.B_RefDocNo,
                              v_TrnTyp: sTrnTyp,
                              v_VocTyp: sBufferObj.B_RefDocTyp,
                            };
                            let resp = await GRNNormal_RefDocumentNo_GETROW(
                              fcheck_null_undefine_replace_empty(payload)
                            );
                            if (
                              resp?.status === 200 &&
                              resp?.data?.ResultSet?.length == 1
                            ) {
                              setBufferObj((obj) => ({
                                ...obj,
                                B_RefDocNo: resp?.data?.ResultSet[0].UID,
                              }));
                            } else {
                              setPoNo(true);
                            }
                          }
                        }}
                        fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                        fGrossAmt={fGrossAmt}
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        xFocusInput={fFocusInput}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        sFocFlagArr={sFocFlagArr}
                        sTypeArr={TypeArr}
                        vRdxGRNtax1={vRdxGRNtax1}
                        vRdxGRNtax2={vRdxGRNtax2}
                        fUnit={fUnit}
                        fUnitRate={fUnitRate}
                        fUnitRateSave_onKeyUp={fUnitRateSave_onKeyUp}
                        fFoc={fFoc}
                        fFocFlag={fFocFlag}
                        fExcise={fExcise}
                        fNetExcise={fNetExcise}
                        fTaxGroup={fTaxGroup}
                        fCessGroup={fCessGroup}
                        fType={fType}
                        fReduceCost={fReduceCost}
                        fCheckbox={fCheckbox}
                        fExpDate={fExpDate}
                        fNarration={fNarration}
                        fNetAmt={fNetAmt}
                        fDiscPer={fDiscPer}
                        fDiscAmt={fDiscAmt}
                        fLDiscPer={fLDiscPer}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                      />
                      {vMediaQuery && (
                        <GRNNormalDetailTblCard
                          data={sDetailGridData}
                          onClick={fDetail_Grid_onRowClick}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "20vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={(item) => {
                            setTimeout(() => {
                              fDetail_Grid_onRowClick(item);
                            }, 300);
                          }}
                          onRowDoubleClick={fDetail_Grid_DoubleClick}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <Footer
                      xErrorMsg={sErrorMsg}
                      xFooterObj={sFooterObj}
                      fFocusRounding={fFooter_Rounding_Focus}
                      fBlurRounding={fFooter_Rounding_Blur}
                      fOpenDiscountPercentageModal={
                        fOpenDiscountPercentageModal
                      }
                      xBuyer={sBuyer}
                      xKey={fKey}
                      vRdxWmsHead={vRdxWmsHead}
                      fBuyer={fBuyer}
                      fHeadNarration={fHeadNarration}
                      fRounding={fRounding}
                      fDiscFlag={fDiscFlag}
                      fFreight={fFreight}
                      fCustomer={fCustomer}
                      fLoadedCost={fLoadedCost}
                      fFreight_xonFocus={fFreight_onFocus}
                      fFreight_xonBlur={fFreight_onBlur}
                      fCustomer_xonFocus={fCustomer_onFocus}
                      fCustomer_xonBlur={fCustomer_onBlur}
                    />
                  </div>
                </Box>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      {/* simple search ref doc  */}
      <GCSimpleSearch
        open={sRefDocSearchModal}
        xCloseSearchModal={(e) => {
          fCloseRefDocSearchModal(
            setRefDocSearchModal,
            fRefDocClearSimpleSearch,
            setRefDocModalArr,
            setRefDocModelObj
          );
        }}
        xTitle={"RefDocInbound"}
        xAnyData={vRdxWmsHead.A_PartyName}
        xModelObj={sRefDocModelObj}
        xSearchEnter={fRefDocSearchEnter}
        xonChangeInputModal={fonChangeRefDocModal}
        xGridArr={sRefInboundGridData}
        xGridDataColumnsSearch={GridDataColumnsRefDocSearch}
        xRowClick={(e) => {
          fRefDocRowClick(
            e,
            dispatch,
            vRdxWmsHead,
            setRefDocSearchModal,
            fRefDocClearSimpleSearch,
            setRefDocModalArr,
            setRefDocModelObj,
            setBufferObj
          );
        }}
        xClearSimpleSearch={fRefDocClearSimpleSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                onRowDoubleClick={fDetail_Grid_DoubleClick}
                hideFooter={sDetailGridData.length < 100}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <Footer
              xErrorMsg={sErrorMsg}
              xFooterObj={sFooterObj}
              fFocusRounding={fFooter_Rounding_Focus}
              fBlurRounding={fFooter_Rounding_Blur}
              fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
              xBuyer={sBuyer}
              xKey={fKey}
              vRdxWmsHead={vRdxWmsHead}
              fBuyer={fBuyer}
              fHeadNarration={fHeadNarration}
              fRounding={fRounding}
              fDiscFlag={fDiscFlag}
              fFreight={fFreight}
              fCustomer={fCustomer}
              fLoadedCost={fLoadedCost}
              fFreight_xonFocus={fFreight_onFocus}
              fFreight_xonBlur={fFreight_onBlur}
              fCustomer_xonFocus={fCustomer_onFocus}
              fCustomer_xonBlur={fCustomer_onBlur}
            />
          </div>
        </Box>
      </Modal>
      {/* Reverse Modal */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={(e) => {
          fCloseReverseTransactionModal(setReverseTransactionModal);
        }}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={(e) => {
          fReverse(fSave, setRevNarr, setReverseTransactionModal);
        }}
      />
      {/* Search  */}
      <GCSearchBtn
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sSearchLoactionArr}
        xSalesGroup={sGCSeachSalesGroupSearch}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangePartyModal={fonChangePartyModal}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        fonChangeSalesGroupModal={fonChangeSalesGroupModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={" GRN - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
        xSalesGroupVal={sSearchModalObj.SalesGroup}
        xPartyVal={sSearchModalObj.Party}
        xPartyNameVal={sSearchModalObj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={fGCSearchBtn_OnCellKeyDown}
      />

      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />

      {/* DiscountPercentage  */}
      <GCDiscountPercentage
        sDiscountPercentageModal={sDiscountPercentageModal}
        fCloseDiscountPercentageModal={fCloseDiscountPercentageModal}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={sDiscPerModelObj.A_TDiscAmt}
        xTDiscPer={sDiscPerModelObj.A_DiscPerc}
        fonChangeInputDiscountModal={fonChangeInputDiscountModal}
        fOnChangeTDiscAmtModal={fOnChangeTDiscAmtModal}
        GetApplyTDiscount={GetApplyTDiscount}
        xErrorMsg_DiscPerc={sErrorMsgDiscountModal.A_DiscPerc}
        xErrorMsg_TDiscAmt={sErrorMsgDiscountModal.A_TDiscAmt}
        xRdx_DocStatus={vRdxWmsHead.A_DocStat !== "ENTER"}
        isDiscounPercField={true}
      />
      {/* Batch  */}
      <GCBatch
        xOpen={sBatchModal} //lutfi
        xErrorMsg={sBatchDetailErrorMsg}
        GridDataBatchRows={sBatch_Load_GridData}
        GridDataBatchColumns={
          SerialDetalModal.Batch == "Y"
            ? GridDataColumnsBatch
            : GridDataColumnSrno
        }
        xOnRowClick={fBatch_RowClick_Load_Grid}
        xBatchUnit={sBatchUnit}
        xTitle={SerialDetalModal.Batch == "Y" ? "Batch setup" : "Serial-setup"}
        xHeadSrNo={sBatchObj.SrNo}
        xHeadItemCode={sBatchObj.ItemCode}
        xHeadItemName={sBatchObj.ItemName}
        xHeadQty={sBatchObj.Qty}
        xHeadUnit={sBatchObj.Unit}
        xHeadBaseQty={sBatchObj.BaseQty}
        xDetailSrNo={sBatchDetailObj.BatchDetail_SrNo}
        xDetailBatchNo={sBatchDetailObj.BatchDetail_BatchNo}
        xDetailMFDate={sBatchDetailObj.BatchDetail_MFDate}
        xDetailExpDate={sBatchDetailObj.BatchDetail_ExpDate}
        xDetailQty={sBatchDetailObj.BatchDetail_Qty}
        xDetailUnit={sBatchDetailObj.BatchDetail_Unit}
        xDetailBaseQty={sBatchDetailObj.BatchDetail_BaseQty}
        xDetailBalanceQty={sBatchDetailObj.BatchDetail_BalanceQty}
        xBatch_fSrNo={""}
        xBatch_fBatchNo={fBatch_BatchNo}
        xBatch_fMFDate={fBatch_MFDate}
        xBatch_fExpDate={fBatch_ExpDate}
        xBatch_fQty={fBatch_Qty}
        xfBatch_Focus_Qty={fBatch_Focus_Qty}
        xfBatch_Blur_Qty={fBatch_Blur_Qty}
        xBatch_fUnit={fBatch_Unit}
        xBatch_fBaseQty={""}
        xfBatch_Close={fBatch_CloseModal}
        xfBatch_New={fBatch_New}
        xfBatch_Delete={fBatch_Delete}
        xfBatch_Save={fBatch_Save}
        xBtnDisable={vRdxWmsHead.A_DocStat != "ENTER"}
        xTotalQty={sBatch_Total_Qty}
        isBatchNoEditable={
          SerialDetalModal.Batch == "Y"
            ? sTrnTyp == "INV03" &&
              batchnoFieldEnable &&
              SerialDetalModal.Batch == "Y"
            : false
        }
        batch={SerialDetalModal.Batch == "Y"}
      />

      {/* GCLoadedCost */}
      <GCLandedCost
        fCustomer={fCustomer}
        fFreight={fFreight}
        open={sLandedCostModal}
        onClose={fCloseLandedCostModal}
        xTitle={"Freight & charges account"}
        xClose={fCloseLandedCostModal}
        xSave={fLoaded_Cost_Save}
        xLoaded_Cost_GRNType={vRdxWmsHead.A_VocTyp}
        xLoaded_Cost_GRNNo={vRdxWmsHead.A_VocNo}
        //input
        xLoaded_Cost_Freight={vRdxWmsHead.A_LC}
        xLoaded_Cost_Customs={vRdxWmsHead.A_Charges1}
        xLoaded_Cost_Discount={
          vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt
        }
        xLoaded_Cost_DiscAmt={sLandedCostDiscAmt}
        //Loaded_Cost
        xLoaded_Cost_AccountArr={sLoadedCostAccountArr}
        xLoaded_Cost_Obj={sLandedCostObjModal}
        xLandedCostObjError={sLandedCostObjError}
        xLoaded_Cost_ToggleArr={sLoadedCostToggleData}
        //freightAcc
        xfLoaded_Cost_Freight_Acc={xfLoaded_Cost_Freight_Acc}
        xfLoaded_Cost_Freight_Name={xfLoaded_Cost_Freight_Name}
        xLoaded_Cost_Freight_Toggle={sLoaded_Cost_Freight_ToggleDropDowm}
        xLoaded_Cost_Freight_onKeyUp={fLoaded_Cost_Freight_onKeyUp}
        xLoaded_Cost_Freight_SearchDropdownObj={
          sLoaded_Cost_Freight_SearchDropdownObj
        }
        xLoaded_Cost_Freight_Dropdown_onChange={
          fLoaded_Cost_Freight_Dropdown_onChange
        }
        xLoaded_Cost_Freight_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Freight_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Freight_Columns_DropdownSearch={
          xLoaded_Cost_Freight_Columns_DropdownSearch
        }
        xLoaded_Cost_Freight_GridData={sLoaded_Cost_Freight_GridData}
        xfLoaded_Cost_Freight_OnCellKeyDown={fLoaded_Cost_Freight_OnCellKeyDown}
        xfLoaded_Cost_Freight__OnRowClick={fLoaded_Cost_Freight_OnRowClick}
        //Customs

        xfLoaded_Cost_Customs_Acc={xfLoaded_Cost_Customs_Acc}
        xfLoaded_Cost_Customs_Name={xfLoaded_Cost_Customs_Name}
        xLoaded_Cost_Customs_Toggle={sLoaded_Cost_Customs_ToggleDropDowm}
        xLoaded_Cost_Customs_onKeyUp={fLoaded_Cost_Customs_onKeyUp}
        xLoaded_Cost_Customs_SearchDropdownObj={
          sLoaded_Cost_Customs_SearchDropdownObj
        }
        xLoaded_Cost_Customs_Dropdown_onChange={
          fLoaded_Cost_Customs_Dropdown_onChange
        }
        xLoaded_Cost_Customs_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Customs_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Customs_Columns_DropdownSearch={
          xLoaded_Cost_Customs_Columns_DropdownSearch
        }
        xLoaded_Cost_Customs_GridData={sLoaded_Cost_Customs_GridData}
        xfLoaded_Cost_Customs_OnCellKeyDown={fLoaded_Cost_Customs_OnCellKeyDown}
        xfLoaded_Cost_Customs__OnRowClick={fLoaded_Cost_Customs_OnRowClick}
        //Discount
        xfLoaded_Cost_Discount_Name={xfLoaded_Cost_Discount_Name}
        xLoaded_Cost_Discount_Toggle={sLoaded_Cost_Discount_ToggleDropDowm}
        xLoaded_Cost_Discount_onKeyUp={fLoaded_Cost_Discount_onKeyUp}
        xLoaded_Cost_Discount_SearchDropdownObj={
          sLoaded_Cost_Discount_SearchDropdownObj
        }
        xLoaded_Cost_Discount_Dropdown_onChange={
          fLoaded_Cost_Discount_Dropdown_onChange
        }
        xLoaded_Cost_Discount_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Discount_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Discount_Columns_DropdownSearch={
          xLoaded_Cost_Discount_Columns_DropdownSearch
        }
        xLoaded_Cost_Discount_GridData={sLoaded_Cost_Discount_GridData}
        xfLoaded_Cost_Discount_OnCellKeyDown={
          fLoaded_Cost_Discount_OnCellKeyDown
        }
        xfLoaded_Cost_Discount__OnRowClick={fLoaded_Cost_Discount_OnRowClick}
        //SplDiscount
        xfLoaded_Cost_SplDiscount_Name={xfLoaded_Cost_SplDiscount_Name}
        xLoaded_Cost_SplDiscount_Toggle={
          sLoaded_Cost_SplDiscount_ToggleDropDowm
        }
        xLoaded_Cost_SplDiscount_onKeyUp={fLoaded_Cost_SplDiscount_onKeyUp}
        xLoaded_Cost_SplDiscount_SearchDropdownObj={
          sLoaded_Cost_SplDiscount_SearchDropdownObj
        }
        xLoaded_Cost_SplDiscount_Dropdown_onChange={
          fLoaded_Cost_SplDiscount_Dropdown_onChange
        }
        xLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_SplDiscount_Columns_DropdownSearch={
          xLoaded_Cost_SplDiscount_Columns_DropdownSearch
        }
        xLoaded_Cost_SplDiscount_GridData={sLoaded_Cost_SplDiscount_GridData}
        xfLoaded_Cost_SplDiscount_OnCellKeyDown={
          fLoaded_Cost_SplDiscount_OnCellKeyDown
        }
        xfLoaded_Cost_SplDiscount__OnRowClick={
          fLoaded_Cost_SplDiscount_OnRowClick
        }
      />
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      <GCMSPUpdate
        xOpen={sMSPUpdateModal}
        fCloseDetailModal={fCloseMSPUpdateModal}
        GridDataMSPUpdateColumns={sGridDataMSPUpdateColumns}
        GridDataMSPUpdateRows={sGridDataMSPUpdateRows}
        xTitle={"Item RSP ,MSP & OverHead Setting - GRN"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
        setGridDataMSPUpdateRows={setGridDataMSPUpdateRows}
        MSPUpdateSaveBtn={
          sGridDataMSPUpdateRows.length === 0
          //  ||   vRdxWmsHead?.A_DocStat?.toUpperCase() === "POST"
        }
        fMSP_SAVE={async () => {
          if (vRdxWmsHead?.A_DocStat?.toUpperCase() == "DELETE") {
            fAlertToast(
              "FAILED",
              "Not Allowed to save in " + vRdxWmsHead?.A_DocStat + "mode"
            );
            return;
          } else {
            const LineItemsArray = sGridDataMSPUpdateRows.map((item) => ({
              ItmCd: item.ItmCd,
              B_unit: item.B_unit,
              SellPr1: item.SellPr1,
              CostPr: item.CostPr,
              GPPerc: item.GPPerc,
              MSP: item.MSP,
              MSPGPPerc: item.MSPGPPerc,
              TSROH: item.TSROH,
            }));

            let iObj = {
              v_VocTyp: vRdxWmsHead.A_VocTyp,
              v_VocNo: vRdxWmsHead.A_VocNo,
              UserCd: vRdxuserInfo.UserID,
              IP: vRdxuserInfo.IP,
              Loc: vRdxWmsHead.A_Loc,
              LineItems: LineItemsArray,
            };
            let vRespi = await WMSIInbound_WMINV03MSPSave_API(iObj);
            if (vRespi?.status === 200) {
              fNewDetail(
                vRdxWmsHead.A_VocNo,
                vRdxWmsHead.A_Rounding,
                vRdxWmsHead.A_VocTyp,
                vRdxWmsHead.TaxType
              );
              fLoad_Grid(
                vRdxWmsHead.A_VocNo, //0
                0, //srno
                vRdxWmsHead.A_Rounding,
                setDetailGridData,
                setFooterObj,
                vRdxWmsHead?.A_VocTyp
              );
              fCloseMSPUpdateModal();
            }
          }
        }}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCPendingStock
        xOpen={sPendingPoModal}
        fCloseDetailModal={fClosePendingPoModal}
        sPendingPoData={sPendingPoData}
        xTitle={"Pending Po Detail"}
      />
      <GCPallet
        xOpen={sPalletModal}
        fCloseDetailModal={fClosePalletModal}
        Data={sPalletData}
        // Data={[]}
        xTitle={"Pallet Detail"}
      />

      <POTypeSearchModal
        open={poType && sBufferObj.B_RefDocTyp == ""}
        onClose={() => {
          setPoType(false);
        }}
        defaultValue={sBufferObj.B_RefDocTypName}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocTypName: e.row.Name1,
            B_RefDocTyp: e.row.UID,
          }));
          setPoType(false);
        }}
      />
      <PoNoSearchModal
        open={poNo && sBufferObj.B_RefDocTyp != ""}
        onClose={() => {
          setPoNo(false);
        }}
        defaultValue={sBufferObj.B_RefDocNo}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocNo: e.row.UID,
          }));
          setPoNo(false);
        }}
        B_RefDocTyp={sBufferObj.B_RefDocTyp}
      />
      <FileUploadModal
        open={ImageUploaderModal}
        fCloseSearchModal={() => {
          setImageUploaderModal(false);
        }}
        A_VocTyp={vRdxWmsHead.A_VocTyp}
        A_VocNo={vRdxWmsHead.A_VocNo}
      />
      <GCStockSetupChangeReq
        open={stockSetupChangeReqModal}
        handleClose={xGCStockSetupChangeReqClose}
        ItemCd={selectedItemData?.B_Itmcd}
        ItemName={selectedItemData?.ItmName}
        vendorCd={vRdxWmsHead?.A_Party}
        vendorName={vRdxWmsHead?.A_PartyName}
        loc={vRdxWmsHead?.A_Loc}
        vRdxuserLoc={vRdxDBLocation}
      />
    </div>
  );
}
